<template>
  <div class="grid-view makeInvoice">
    <!--    <div class="app-main-page makeInvoice">-->
    <!--    </template>-->
    <!--  todo: config-module  -->
    <div v-if="pageMode===0" class="main-content">
      <search-item
        key="tabMakeInvoice_makeInvoiceMethod"
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        :is-append-query="true"
        :search-item-code="normalSearchItemConfigs[searchConditions.makeInvoiceMethod-1].searchItemCode"
        :config-module="normalSearchItemConfigs[searchConditions.makeInvoiceMethod-1].configModule"
        :grid-config-module="normalSearchItemConfigs[searchConditions.makeInvoiceMethod-1].gridConfigModule"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="normalSearchItemConfigs[searchConditions.makeInvoiceMethod-1].simQueryPlaceholder"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataBykeyWord"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div slot="operations">
          <div v-if="pageMode===1" style="display: inline-block; font-size: 14px; color: orangered;">
            <span>
              {{ makeInvoiceBtnText.hedgeMakeInvoiceLabel }}</span>
          </div>
          <el-button v-if="pageMode===1" type="primary" no="1" @click="toChangePageMode">{{ $t('Invoice.invoice_return') }}</el-button>
          <el-button v-if="pageMode===1" type="primary" no="2" @click="toHedgeMakeInvoice">{{ $t('Invoice.invoice_confirm') }}</el-button>
          <el-button v-if="pageMode!==1 && btnMakeInvoice" type="primary" no="3" @click="toMakeInvoice">{{ makeInvoiceBtnText.makeInvoiceBtn }}</el-button>
          <el-button v-if="pageMode!==1" type="primary" no="4" @click="toHedgeMakeInvoicePage">{{ makeInvoiceBtnText.hedgeMakeInvoiceBtn }}</el-button>
          <!-- 费用开票方式的标记按钮 -->
          <template v-if="searchConditions.makeInvoiceMethod===1">
            <el-button type="primary" no="17" @click="signChargeEvent">{{ $t('CargoMsg.Cargo_Mark') }}</el-button>
            <el-button type="primary" no="18" @click="cancelSignChargeEvent">{{ $t('CargoMsg.Cargo_CancelMark') }}</el-button>
          </template>
          <!-- 业务开票方式的标记按钮 -->
          <template v-if="searchConditions.makeInvoiceMethod===2">
            <el-button type="primary" no="19" @click="signBusinessEvent">{{ $t('CargoMsg.Cargo_Mark') }}</el-button>
            <el-button type="primary" no="20" @click="cancelSignBusinessEvent">{{ $t('CargoMsg.Cargo_CancelMark') }}</el-button>
          </template>
          <!-- 账单开票方式的标记按钮 -->
          <template v-if="searchConditions.makeInvoiceMethod===3">
            <el-button v-if="pageMode!==1" type="primary" no="5" @click="unConfirmBilling">{{ $t('Invoice.invoice_cancelBillConfirmation') }}</el-button>
            <el-button type="primary" no="6" @click="signEvent">{{ $t('CargoMsg.Cargo_Mark') }}</el-button>
            <el-button type="primary" no="7" @click="cancelSignEvent">{{ $t('CargoMsg.Cargo_CancelMark') }}</el-button>
          </template>
          <el-button v-if="pageMode!==1 && searchConditions.paymentType === -1 && $checkPermission(['button_ACInvoice_autoCheckInvoicing'])" type="primary" no="8" @click="autoCheckInvoicing">{{ $t('Invoice.AutoCheckInvoicing' ) }}</el-button>
          <i v-if="pageMode!==1 && searchConditions.paymentType === -1 && $checkPermission(['button_ACInvoice_autoCheckInvoicing'])" slot="reference" no="9" class="el-icon-question" style="color: #00A6F4;display: inline-block;position: fixed;" :title="$t('Invoice.AutoCheckInvoicingToolTips')" />
          <el-button v-if="$checkPermission(['button_tabMakeInvoice_invoicePool']) && pageMode !== 1 && searchConditions.paymentType === 0" type="primary" no="showInvoicePoolDialog" @click="showInvoicePoolDialog">{{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}</el-button>
        </div>
        <template slot="searchAreaHeader">
          <div class="app-main-inner-row extension-conditions-form">
            <el-form :inline="true" label-position="left">
              <el-form-item :label="$t('Invoice.invoice_revenueAndExpenditureMethod')" class="el-form-item-search">
                <el-radio-group v-model="searchConditions.paymentType" no="10" @change="initCustomSearchItems">
                  <el-radio :label="-1" :disabled="!searchConditions.allowInvoiceQueryAll">{{ $t('Invoice.invoice_all') }}</el-radio>
                  <el-radio v-if="$checkPermission(['button_tabMakeInvoice_arCharge'])" :label="1">{{ $t('Invoice.invoice_receivables') }}</el-radio>
                  <el-radio v-if="$checkPermission(['button_tabMakeInvoice_apCharge'])" :label="0">{{ $t('Invoice.invoice_payables') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_feeType')" class="el-form-item-search">
                <el-radio-group v-model="searchConditions.chargeTypeGroup" no="11">
                  <el-radio :label="-1" :disabled="!searchConditions.createOverseaCharge">{{ $t('Invoice.invoice_all') }}</el-radio>
                  <el-radio :label="0">{{ $t('Invoice.invoice_domestic') }}</el-radio>
                  <el-radio :label="1" :disabled="!searchConditions.createOverseaCharge">{{ $t('Invoice.invoice_international') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_invoicingMethod')" class="el-form-item-search">
                <el-radio-group v-model="searchConditions.makeInvoiceMethod" no="12" @change="makeInvoiceMethodChange">
                  <el-radio :label="1">{{ $t('Invoice.invoice_charges') }}</el-radio>
                  <el-radio :label="2">{{ $t('Invoice.invoice_business') }}</el-radio>
                  <el-radio :label="3">{{ $t('Invoice.invoice_bill') }}</el-radio>
                  <el-radio :label="4">{{ $t('Invoice.invoice_accountStatement') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="useOrderCenterMode" label-width="0" class="el-form-item-search">
                <el-checkbox v-model="searchConditions.internalCharge" no="13">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
              </el-form-item>
              <el-form-item v-if="pageMode===0" label="" class="el-form-item-search">
                <el-checkbox no="14">{{ $t('Invoice.invoice_defaultInformation') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="inputDateLabel" class="el-form-item-search">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateStart"
                        no="15"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        :editable="false"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="2"><span>{{ $t('Invoice.invoice_dateTo') }}</span></el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateEnd"
                        no="16"
                        type="date"
                        clearable
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label-width="0">
                      <el-checkbox v-model="allowTwoYearOutside" no="17">{{ $t('Invoice.invoice_queryLotsOfData') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </search-item>
      <div v-if="pageMode === 0" class="section grid-wrapper">
        <!--        按费用-->
        <cargo-ag-grid-wrapper
          v-show="pageMode===0"
          v-if="searchConditions.makeInvoiceMethod===1"
          key="190601"
          config-module="190601"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="chargeGrid.gridParams"
          :grid-options="chargeGrid.gridOptions"
          :column-defs="chargeGrid.columnDefs"
          :row-data="chargeGrid.rowData"
          :show-row-groups="dataListDragGroup"
          :enable-quick-value-convert="true"
        />
        <!--        按业务-->
        <cargo-ag-grid-wrapper
          v-show="pageMode===0"
          v-if="searchConditions.makeInvoiceMethod===2"
          key="190602"
          config-module="190602"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billingJobGrid.gridParams"
          :grid-options="billingJobGrid.gridOptions"
          :column-defs="billingJobGrid.columnDefs"
          :row-data="billingJobGrid.rowData"
          :show-row-groups="dataListDragGroup"
          :enable-quick-value-convert="true"
        />
        <cargo-ag-grid-wrapper
          v-show="pageMode===0"
          v-if="searchConditions.makeInvoiceMethod===3"
          key="190603"
          config-module="190603"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billingGrid.gridParams"
          :grid-options="billingGrid.gridOptions"
          :column-defs="dynamicColumnDefs"
          :row-data="billingGrid.rowData"
          :show-row-groups="dataListDragGroup"
          :enable-quick-value-convert="true"
        />
        <cargo-ag-grid-wrapper
          v-show="pageMode===0"
          v-if="searchConditions.makeInvoiceMethod===4"
          key="190604"
          config-module="190604"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billingGroupGrid.gridParams"
          :grid-options="billingGroupGrid.gridOptions"
          :column-defs="dynamicColumnDefs"
          :row-data="billingGroupGrid.rowData"
          :show-row-groups="dataListDragGroup"
          :enable-quick-value-convert="true"
        />
      </div>
    </div>
    <!-- 对冲开票 -->
    <div v-if="pageMode===1" class="main-content">
      <search-item
        key="tabMakeInvoice_makeInvoiceMethodHedge"
        ref="searchItemHedge"
        :show-more-scheme="true"
        :show-simple="true"
        :is-append-query="true"
        :expand-adv="true"
        :search-item-code="hedgeSearchItemConfigs[searchConditionsHedge.makeInvoiceMethod-1].searchItemCode"
        :config-module="hedgeSearchItemConfigs[searchConditionsHedge.makeInvoiceMethod-1].configModule"
        :grid-config-module="hedgeSearchItemConfigs[searchConditionsHedge.makeInvoiceMethod-1].gridConfigModule"
        :auto-init="searchItemAutoInitHedge"
        :custom-search-items="initCustomSearchItemsHedge"
        :custom-sim-query-placeholder="hedgeSearchItemConfigs[searchConditionsHedge.makeInvoiceMethod-1].simQueryPlaceholder"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataBykeyWord"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItemsHedge=value}"
      >
        <div slot="operations">
          <div v-if="pageMode===1" style="display: inline-block; font-size: 14px; color: orangered;">
            <span style="padding-right: 15px; font-size: 14px;">
              {{ makeInvoiceBtnText.hedgeMakeInvoiceLabel }}</span>
          </div>
          <el-button v-if="pageMode===1" type="primary" no="18" @click="toChangePageMode">{{ $t('Invoice.invoice_return') }}</el-button>
          <el-button v-if="pageMode===1" type="primary" no="19" @click="toHedgeMakeInvoice">{{ $t('Invoice.invoice_confirm') }}</el-button>
          <el-button v-if="pageMode!==1" type="primary" no="20" @click="toMakeInvoice">{{ makeInvoiceBtnText.makeInvoiceBtn }}</el-button>
          <el-button v-if="pageMode!==1" type="primary" no="21" @click="toHedgeMakeInvoicePage">{{ makeInvoiceBtnText.hedgeMakeInvoiceBtn }}</el-button>
          <template v-if="searchConditions.makeInvoiceMethod===3">
            <el-button v-if="pageMode!==1" type="primary" no="22" @click="unConfirmBilling">{{ $t('Invoice.invoice_cancelBillConfirmation') }}</el-button>
            <el-button type="primary" no="23" @click="signEvent">{{ $t('CargoMsg.Cargo_Mark') }}</el-button>
            <el-button type="primary" no="24" @click="cancelSignEvent">{{ $t('CargoMsg.Cargo_CancelMark') }}</el-button>
          </template>
        </div>
        <template slot="searchAreaHeader">
          <div class="app-main-inner-row extension-conditions-form">
            <!-- 对冲开票 -->
            <el-form :inline="true" label-position="left">
              <el-form-item :label="$t('Invoice.invoice_revenueAndExpenditureMethod')" class="el-form-item-search">
                <el-radio-group v-model="searchConditionsHedge.paymentType" no="25">
                  <el-radio :label="-1" :disabled="!searchConditionsHedge.allowInvoiceQueryAll">{{ $t('Invoice.invoice_all') }}</el-radio>
                  <el-radio v-if="$checkPermission(['button_tabMakeInvoice_arCharge'])" :label="1" :disabled="!properties.isAr">{{ $t('Invoice.invoice_receivables') }}</el-radio>
                  <el-radio v-if="$checkPermission(['button_tabMakeInvoice_apCharge'])" :label="0" :disabled="!properties.isAr">{{ $t('Invoice.invoice_payables') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_feeType')" class="el-form-item-search">
                <el-radio-group v-model="searchConditionsHedge.chargeTypeGroup" no="26">
                  <el-radio :label="-1" :disabled="!searchConditionsHedge.createOverseaCharge">{{ $t('Invoice.invoice_all') }}</el-radio>
                  <el-radio :label="0">{{ $t('Invoice.invoice_domestic') }}</el-radio>
                  <el-radio :label="1" :disabled="!searchConditionsHedge.createOverseaCharge">{{ $t('Invoice.invoice_international') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_invoicingMethod')" class="el-form-item-search">
                <el-radio-group v-model="searchConditionsHedge.makeInvoiceMethod" no="27" @change="makeInvoiceMethodChange">
                  <el-radio :label="1">{{ $t('Invoice.invoice_charges') }}</el-radio>
                  <el-radio :label="2">{{ $t('Invoice.invoice_business') }}</el-radio>
                  <el-radio :label="3">{{ $t('Invoice.invoice_bill') }}</el-radio>
                  <el-radio :label="4">{{ $t('Invoice.invoice_accountStatement') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="useOrderCenterMode" class="el-form-item-search">
                <el-checkbox v-model="searchConditionsHedge.internalCharge" no="28">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
              </el-form-item>
              <el-form-item v-if="pageMode===0" label="" class="el-form-item-search">
                <el-checkbox no="29">{{ $t('Invoice.invoice_defaultInformation') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="inputDateLabel" class="el-form-item-search">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateStart"
                        no="30"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        :editable="false"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="2"><span>{{ $t('Invoice.invoice_dateTo') }}</span></el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateEnd"
                        no="31"
                        type="date"
                        clearable
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label-width="0">
                      <el-checkbox v-model="allowTwoYearOutside" no="32">{{ $t('Invoice.invoice_queryLotsOfData') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </search-item>
      <!-- 对冲开票 -->
      <div v-if="pageMode === 1" class="section grid-wrapper">
        <cargo-ag-grid
          v-show="pageMode===1"
          v-if="searchConditionsHedge.makeInvoiceMethod===1"
          key="1906012"
          config-module="1906012"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="chargeGridHedge.gridParams"
          :grid-options="chargeGridHedge.gridOptions"
          :column-defs="chargeGrid.columnDefs"
          :row-data="chargeGridHedge.rowData"
          :enable-quick-value-convert="true"
        />
        <cargo-ag-grid
          v-show="pageMode===1"
          v-if="searchConditionsHedge.makeInvoiceMethod===2"
          key="1906022"
          config-module="1906022"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billingJobGridHedge.gridParams"
          :grid-options="billingJobGridHedge.gridOptions"
          :column-defs="billingJobGrid.columnDefs"
          :row-data="billingJobGridHedge.rowData"
          :enable-quick-value-convert="true"
        />
        <cargo-ag-grid
          v-show="pageMode===1"
          v-if="searchConditionsHedge.makeInvoiceMethod===3"
          key="1906032"
          config-module="1906032"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billingGridHedge.gridParams"
          :grid-options="billingGridHedge.gridOptions"
          :column-defs="dynamicColumnDefs"
          :row-data="billingGridHedge.rowData"
          :enable-quick-value-convert="true"
        />
        <cargo-ag-grid
          v-show="pageMode===1"
          v-if="searchConditionsHedge.makeInvoiceMethod===4"
          key="1906042"
          config-module="1906042"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billingGroupGridHedge.gridParams"
          :grid-options="billingGroupGridHedge.gridOptions"
          :column-defs="dynamicColumnDefs"
          :row-data="billingGroupGridHedge.rowData"
          :enable-quick-value-convert="true"
        />
      </div>
    </div>
    <div id="footer-wrapper2" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <charge-count-group
          v-show="pageMode===0"
          v-if="reCalc && searchConditions.makeInvoiceMethod===1"
          key="1906011"
          :selected-count="totalAmountToCurrencyChargeGrid.selectedCount"
          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyChargeGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
          source="invoiceList"
        />
        <charge-count-group
          v-show="pageMode===0"
          v-if="reCalc && searchConditions.makeInvoiceMethod===2"
          key="1906021"
          :selected-count="totalAmountToCurrencyBillingJobGrid.selectedCount"
          :data-provider="totalAmountToCurrencyBillingJobGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingJobGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <charge-count-group
          v-show="pageMode===0"
          v-if="reCalc && searchConditions.makeInvoiceMethod===3"
          key="1906031"
          :selected-count="totalAmountToCurrencyBillingGrid.selectedCount"
          :data-provider="totalAmountToCurrencyBillingGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <charge-count-group
          v-show="pageMode===0"
          v-if="reCalc && searchConditions.makeInvoiceMethod===4"
          key="1906041"
          :selected-count="totalAmountToCurrencyBillingGroupGrid.selectedCount"
          :data-provider="totalAmountToCurrencyBillingGroupGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingGroupGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <!-- 对冲开票 -->
        <charge-count-group
          v-show="pageMode===1"
          v-if="reCalc && searchConditionsHedge.makeInvoiceMethod===1"
          key="19060121"
          :selected-count="totalAmountToCurrencyChargeGridHedge.selectedCount"
          :data-provider="totalAmountToCurrencyChargeGridHedge.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyChargeGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <charge-count-group
          v-show="pageMode===1"
          v-if="reCalc && searchConditionsHedge.makeInvoiceMethod===2"
          key="19060221"
          :selected-count="totalAmountToCurrencyBillingJobGridHedge.selectedCount"
          :data-provider="totalAmountToCurrencyBillingJobGridHedge.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingJobGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <charge-count-group
          v-show="pageMode===1"
          v-if="reCalc && searchConditionsHedge.makeInvoiceMethod===3"
          key="19060321"
          :selected-count="totalAmountToCurrencyBillingGridHedge.selectedCount"
          :data-provider="totalAmountToCurrencyBillingGridHedge.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <charge-count-group
          v-show="pageMode===1"
          v-if="reCalc && searchConditionsHedge.makeInvoiceMethod===4"
          key="19060421"
          :selected-count="totalAmountToCurrencyBillingGroupGridHedge.selectedCount"
          :data-provider="totalAmountToCurrencyBillingGroupGridHedge.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingGroupGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
      </div>
      <div v-show="pageMode===0 && appendQuery" v-if="searchConditions.makeInvoiceMethod===1" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.totalChargeGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===0 && !appendQuery"
        v-if="searchConditions.makeInvoiceMethod===1"
        config-module="190601"
        :total="searchConditions.totalChargeGrid"
        :page.sync="searchConditions.pageNumChargeGrid"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
      <div v-show="pageMode===0 && appendQuery" v-if="searchConditions.makeInvoiceMethod===2" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.totalBillingJobGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===0 && !appendQuery"
        v-if="searchConditions.makeInvoiceMethod===2"
        config-module="190602"
        :total="searchConditions.totalBillingJobGrid"
        :page.sync="searchConditions.pageNumBillingJobGrid"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
      <div v-show="pageMode===0 && appendQuery" v-if="searchConditions.makeInvoiceMethod===3" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.totalBillingGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===0 && !appendQuery"
        v-if="searchConditions.makeInvoiceMethod===3"
        config-module="190603"
        :total="searchConditions.totalBillingGrid"
        :page.sync="searchConditions.pageNumBillingGrid"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
      <div v-show="pageMode===0 && appendQuery" v-if="searchConditions.makeInvoiceMethod===4" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.totalBillingGroupGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===0 && !appendQuery"
        v-if="searchConditions.makeInvoiceMethod===4"
        config-module="190604"
        :total="searchConditions.totalBillingGroupGrid"
        :page.sync="searchConditions.pageNumBillingGroupGrid"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
      <!-- 对冲开票 -->
      <div v-show="pageMode===1 && appendQuery" v-if="searchConditions.makeInvoiceMethod===1" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditionsHedge.totalChargeGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===1 && !appendQuery"
        v-if="searchConditionsHedge.makeInvoiceMethod===1"
        config-module="1906012"
        :total="searchConditionsHedge.totalChargeGrid"
        :page.sync="searchConditionsHedge.pageNumChargeGrid"
        :limit.sync="searchConditionsHedge.pageSize"
        @pagination="fetchDataByPage"
      />
      <div v-show="pageMode===1 && appendQuery" v-if="searchConditions.makeInvoiceMethod===2" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditionsHedge.totalBillingJobGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===1 && !appendQuery"
        v-if="searchConditionsHedge.makeInvoiceMethod===2"
        config-module="1906022"
        :total="searchConditionsHedge.totalBillingJobGrid"
        :page.sync="searchConditionsHedge.pageNumBillingJobGrid"
        :limit.sync="searchConditionsHedge.pageSize"
        @pagination="fetchDataByPage"
      />
      <div v-show="pageMode===1 && appendQuery" v-if="searchConditions.makeInvoiceMethod===3" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditionsHedge.totalBillingGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===1 && !appendQuery"
        v-if="searchConditionsHedge.makeInvoiceMethod===3"
        config-module="1906032"
        :total="searchConditionsHedge.totalBillingGrid"
        :page.sync="searchConditionsHedge.pageNumBillingGrid"
        :limit.sync="searchConditionsHedge.pageSize"
        @pagination="fetchDataByPage"
      />
      <div v-show="pageMode===1 && appendQuery" v-if="searchConditions.makeInvoiceMethod===4" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditionsHedge.totalBillingGroupGrid"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="pageMode===1 && !appendQuery"
        v-if="searchConditionsHedge.makeInvoiceMethod===4"
        config-module="1906042"
        :total="searchConditionsHedge.totalBillingGroupGrid"
        :page.sync="searchConditionsHedge.pageNumBillingGroupGrid"
        :limit.sync="searchConditionsHedge.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>

    <!--    </div>-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <make-invoice-step-one-dialog
      :visible="this.step === 'step1'"
      :title="this.title"
      :params="makeInvoiceDialog.params"
      :properties="this.properties"
      :location="location"
      view-source="tabMakeInvoice"
      @update:visible="visible => handleStepVisibleChange('step1', visible)"
      @lastFinsh="lastFinsh"
      @toStepHandler="toStepHandler"
      @generatedHandler="generatedHandler"
    />
    <!--  合并后两步弹窗页不再渲染（原 Step2 已并入 Step1）；组件文件保留，由后续 cleanup 决定是否删除  -->
    <make-invoice-step-two-dialog
      v-if="false"
      ref="makeInvoiceStepTwoDialog"
      :visible="false"
      :title="this.title"
      :params="makeInvoiceStepTwoDialog.params"
      :properties="this.properties"
      :location="location"
      @update:visible="visible => handleStepVisibleChange('step2', visible)"
      @lastFinsh="lastFinsh"
      @toStepHandler="toStepHandler"
      @generatedHandler="generatedHandler"
      @toSaveCatchHandler="toSaveCatchHandler"
    />
    <!-- 开票弹窗-详情页面 -->
    <invoice-detail-dialog
      ref="makeInvoiceDialog"
      :visible="this.step === 'step3'"
      :title="this.title"
      :params="makeInvoiceDialog.params"
      :properties="this.properties"
      :location="location"
      @update:visible="visible => handleStepVisibleChange('step3', visible)"
      @lastFinsh="lastFinsh"
      @toStepHandler="toStepHandler"
      @pageChange="pageChange"
    />
    <!--开票(通用版本) 其它模块开票时使用，比如账单-->
    <make-invoice-dialog
      ref="invoice"
      view-source="invoice"
      :location="location"
      @reloadData="reloadData"
      @toStepHandler="toStepHandler"
    />

    <!--标记账单弹出窗-->
    <sign-billing-dialog
      :visible.sync="signBillingDialog.visible"
      :billing-keys="signBillingDialog.billingKeys"
      @signBillingCallBack="signBillingCallBack"
    />

    <!--标记费用弹出窗-->
    <sign-dialog
      :visible.sync="signChargeDialog.visible"
      :type="searchConditions.makeInvoiceMethod"
      :title="$t('Clearing.MarkCharge')"
      @signBillingCallBack="signChargeCallBack"
    />

    <!--标记业务弹出窗-->
    <sign-dialog
      :visible.sync="signBusinessDialog.visible"
      :type="searchConditions.makeInvoiceMethod"
      :title="$t('Clearing.MarkJob')"
      @signBillingCallBack="signBusinessCallBack"
    />

    <!--自动勾选开票金额弹出框-->
    <el-dialog
      v-el-drag-dialog
      :title="$t('Invoice.AutoCheckInvoicingAmount')"
      :visible="autoCheckInvoiceDialog.visible"
      :close-on-click-modal="false"
      append-to-body
      :show-close="false"
      width="400px"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item label-width="0">
              <div style="display: flex">
                <div>
                  <span>{{ $t('Invoice.DefaultInvoicingAmount') }}</span>
                  <i slot="reference" class="el-icon-question" style="color: #00A6F4;display: inline-block;position: fixed;" :title="$t('Invoice.AutoCheckInvoicingDialogToolTips')" />
                </div>
                <div>
                  <el-input-number v-model="autoCheckInvoiceDialog.amount" no="33" style="width: 100px;margin-left: 20px;" :controls="false" :min="0" :precision="2" />
                  <span style="margin-left: 5px;">CNY</span>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" no="34" @click="autoCheckInvoiceConfirm">{{ $t('Invoice.invoice_confirm') }}</el-button>
        <el-button no="35" @click="autoCheckInvoiceDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 发票池弹窗 -->
    <invoice-pool-dialog
      v-if="invoicePoolDialog.visible"
      :visible.sync="invoicePoolDialog.visible"
      :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
      :selected-entities="invoicePoolDialog.selectedEntities"
      :make-invoice-method="invoicePoolDialog.makeInvoiceMethod"
      :source="invoicePoolDialog.source"
      :operation="invoicePoolDialog.operation"
      :callback="invoicePoolCallBack"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { DocumentManage, ensureExecuteSuccess, stringToBool } from '@/utils/commonUtil'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { getGridSelected, getGridSelectedIds, recordSelectedStatus } from '@/utils/agGrid'
import makeInvoiceStepOneDialog from './makeInvoiceStepOneDialog'
import makeInvoiceStepTwoDialog from './makeInvoiceStepTwoDialog'
import invoiceDetailDialog from './invoiceDetailDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { queryChargeList, queryChargeJobList, getNotInvoiceCharges } from '@/api/clearing/invoice'
import { queryInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'

import lodash from 'lodash'
import { cacheName, cache } from '@/utils/cacheManager'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import StrUtils from '@/utils/StrUtils'
import moment from 'moment'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import { Once } from '@/utils/commonUtil'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'
import TabBillingHp from '../BillingNative/tabBillingHP'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { cancelSignBilling } from '@/api/clearing/billingNative'
import signBillingDialog from './signBillingDialog'
import TabBillingGroupHp from '../BillingNative/tabBillingGroupHP'
import { formatNumberToThousands } from '@/utils'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import $store from '@/store'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import { LOG_MAKE_INVOICE, TAX_EXEMPTION, TAX_NOT_EXEMPTION } from '@/class/cargo/model/parameters/SystemConstants'
import BigNumber from 'bignumber.js'
import * as NumberUtils from '@/utils/NumberUtils'
import { existWorkflowGroup } from '@/api/workflow'
import { MAKE_INVOICE_BILLING, MAKE_INVOICE_INTERNAL_INVOICE } from '@/class/cargo/model/parameters/WorkflowConstants'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { queryChargePushRecord } from '@/api/clearing/charge'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import SignDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/signDialog.vue'
import { cancelSignCharge, cancelSignJob, signCharge, signJob } from '@/api/clearing/invoice'
import invoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog.vue'

export default {
  name: 'TabMakeInvoice',
  components: {
    invoicePoolDialog,
    SignDialog,
    cargoAgGridWrapper, searchItem, cargoTemplateSelectorDialog, makeInvoiceStepOneDialog, makeInvoiceStepTwoDialog, invoiceDetailDialog, ChargeCountGroup, makeInvoiceDialog, signBillingDialog },
  props: {
    isShow: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      appendQuery: false, // 追加查询
      localCurrency: 'RMB',
      reCalc: true,
      loading: false,
      documentManage: new DocumentManage(),
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false,
      /**
       * 页面模式: 0-开发/收票 1-对冲开票/对冲收票
       */
      pageMode: 0,
      defaultSearchItems: [],
      searchConditions: {
        total: 0,
        totalChargeGrid: 0, // 按费用
        totalBillingJobGrid: 0, // 按业务
        totalBillingGrid: 0, // 按账单
        totalBillingGroupGrid: 0, // 按对账单
        pageNum: 1,
        pageNumChargeGrid: 1, // 按费用
        pageNumBillingJobGrid: 1, // 按业务
        pageNumBillingGrid: 1, // 按账单
        pageNumBillingGroupGrid: 1, // 按对账单
        pageSize: 20,
        likeName: '',
        paymentType: 1, // 收付方式，是否应收
        chargeTypeGroup: 0, // 费用类型，是否国外
        businessDateSearch: [], // 业务日期
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'),
        inputDateEnd: '',
        isNeedInvoice: 1, // 是否需要开票
        commission: 0, // 是否佣金
        advance: 0, // 是否垫付
        shared: 0, // 是否分摊费用
        paidOff: -1, // 是否销账
        hasInvoice: 0, // 是否开票
        hasBilling: -1, // 是否关联账单
        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        snapshotConditionsCharge: [], // 高级查询条件（点击查询时的快照状态）
        requiresCharge: [],
        snapshotConditionsJob: [],
        requiresChargeJob: [],
        billingHasPaidOff: '0', // 对账-费用-是否已核销(对账) 0.否 1.是
        billingHasBilling: '0', // 对账-费用-是否已生成账单(对账) 0.否 1.是
        billingHasBillPayment: '0', // 对账-费用-是否已申请付款(对账) 0.否 1.是
        allowInvoiceQueryAll: false, // AllowInvoiceQueryAll, 开票界面是否允许查询全部 0.不允许 1.允许
        createOverseaCharge: false, // CreateInvoiceByOverseaCharge, 是否允许国外费用开票
        invoiceReceiveChargeState: '', // InvoiceReceiveChargeState, 开票-应收费用-费用状态查询(发票)
        invoicePayChargeState: '', // InvoicePayChargeState, 开票-应付费用-费用状态查询(发票)
        jobStateParam: '', // InvoiceJobState, 开票-未开票-业务状态查询(发票)
        chargeStateParam: '', // InvoiceChargeState, 开票-费用-费用状态查询(发票)
        confirmStateParam: '', // InvoiceChargeConfirmState, 开票-费用-费用确认状态查询(发票)
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 确认状态
        jobStateParam2: '', // BillingJobState, 对账-费用-业务状态查询(对账)
        chargeStateParam2: '', // BillingChargeState, 对账-费用-费用状态查询(对账)
        confirmStateParam2: '', // BillingChargeConfirmState, 对账-费用-费用确认状态查询
        jobStates2: [], // 业务状态
        chargeStates2: [], // 费用状态
        confirmStates2: [], // 确认状态
        hasDiffCharge: -1, // 是否关联差异对冲费用
        exceptKeys: [],
        accountId: 0, // 对冲开票结算单位
        billingJobStates: [], // 账单-业务状态
        billingStates: [], // 账单-账单状态
        billingClearingStates: [], // 账单-核销状态
        billingStateParam: 'InvoiceBillingState',
        billingClearingStateParam: 'InvoiceClearingState',
        billingJobStateParam: 'InvoiceJobState',
        billingRequires: ['writeoff', 'invoice', 'invoiceNo'],
        billingClearingState: -1, // 核销状态（0:有未销账,1:有已销账）
        selectedEntitiesForHedging: [],
        billingGroupStates: [BillingConstants.BILLING_VERIFIED], // 对账单状态
        billingGroupJobStates: [], // 对账单业务状态
        billingGroupJobStateParam: 'InvoiceJobState',
        billingGroupRequires: ['writeoff', 'invoice'],
        billingGroupClearingState: -1, // 核销状态（0:有未销账,1:有已销账）
        snapshotConditionsBilling: [],
        snapshotConditionsBillingGroup: [],
        internalCharge: false // 内结
      },
      perConfigName: '',
      gridRefreshId: 0,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      chargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: params => !!params.data, pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: true,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.branchId)
                  },
                  printMethod: this.toSearchTemplate
                }
              }
            }, width: 150, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_settlementCompany'), field: 'accountId',
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
            }, width: 180, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_mblNo'), field: 'jobMbl', width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_separateNumber'), field: 'jobHbl', width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_invoiceHeader'), field: 'invoiceTitle', width: 200, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_billNo'), field: 'billingNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_accountStatementNo'), field: 'billingGroupNo', width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_customer'), field: 'jobCustomerId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }, width: 180, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_businessType'), field: 'jobLob',
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_bargeETD'), field: 'bargeETD',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'jobVesselFlight', width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'loadingPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            filter: false,
            filterParams: {},
            width: 120
          },
          {
            headerName: this.$t('Partners.isFba'),
            colId: 'fba',
            field: 'fba',
            width: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }
          },
          {
            headerName: this.$t('SeaExport.TaxNature'),
            field: 'jobTaxNature',
            colId: 'jobTaxNature',
            cellRenderer: params => {
              return ColumnUtils.taxNatureLabelFunction(params.value)
            },
            width: 120
          },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', initialWidth: 120,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.FieldOperation'), field: 'jobSiteOp', colId: 'jobSiteOp', initialWidth: 120,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
            colId: 'warehouseCode',
            field: 'warehouseCode',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.DestinationDistribution'),
            colId: 'destinationDistribution',
            field: 'destinationDistribution',
            width: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
            }
          },
          {
            headerName: this.$t('FbaJob.ExpressNo'),
            colId: 'expressNo',
            field: 'expressNo',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.RemoteWarehouse'),
            colId: 'remoteWarehouse',
            field: 'remoteWarehouse',
            width: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }
          },
          {
            headerName: 'Shipment Id',
            colId: 'shipmentId',
            field: 'shipmentId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: 'Reference Id',
            colId: 'referenceId',
            field: 'referenceId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'destinationPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            filter: false,
            filterParams: {},
            width: 120
          },
          { headerName: this.$t('Invoice.invoice_sales'), field: 'jobSales',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_accrued'), field: 'jobIsProvisioned',
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_operation'), field: 'jobOp',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_domesticOrInternational'), field: 'isOversea',
            cellRenderer: (params) => {
              return ColumnUtils.overseaLabelFunc(params.value)
            }, width: 120 },
          { headerName: this.$t('Invoice.invoice_paymentType'), field: 'isReceivable',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_feeStatus'), field: 'chargeState',
            cellRenderer: (params) => {
              return ColumnUtils.chargeStateLabFun(Number(params.value))
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_confirmStatus'), field: 'confirmState',
            cellRenderer: (params) => {
              return ColumnUtils.chargeConfirmStateLabFun(Number(params.value))
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }, width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_customJobType'), field: 'jobCustomJobType',
            valueGetter: (params) => {
              return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.jobLob, params.data.fba)
            }, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_quantity'), field: 'quantity', width: 100, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_taxExcludedPrice'), field: 'excludingTaxAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 100, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_itemNo'), field: 'jobPono', hide: true, width: 130, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_contactPerson'), field: 'contactPerson', width: 100, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_theAmountOfWriteOffs'), field: 'verifiedAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_amountNotWrittenOff'), field: 'unverifiedAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120, enableRowGroup: true,
            summaryMode: 'sum' },
          { headerName: this.$t('Invoice.invoice_invoicingMethod'), field: 'cdInvoiceMode', hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.invoiceModeLableFun(Number(params.value))
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_paymentApplicationNo'), field: 'billPaymentNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_bookingNo'), field: 'jobBookingNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_containerNo'), field: 'containerContainerNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_businessReferenceNumber'), field: 'jobCustomerRefNo', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField1'), field: 'jobUserDefinedField1', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField2'), field: 'jobUserDefinedField2', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField3'), field: 'jobUserDefinedField3', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_userDefinedField4'), field: 'jobUserDefinedField4', hide: true, width: 140, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_salesDepartment'), field: 'jobSalesDepartment', hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_chargesRemarks'), field: 'remarks', width: 160, enableRowGroup: true },
          { headerName: this.$t('SeaExport.CustomerService'), field: 'jobCsr', hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_containerDescription'), field: 'containerDescription', hide: true, width: 180, enableRowGroup: true },
          { headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'), field: 'receivableChargeLockedStatus', hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.chargeLockedStatus(Number(params.value))
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('SeaExport.PayableChargeLockedStatus'), field: 'payableChargeLockedStatus', hide: true, width: 100, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.chargeLockedStatus(Number(params.value))
            } },
          { headerName: 'S/O No.', field: 'soNo', hide: true, width: 100, enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.soNoLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'changer',
            field: 'changer',
            initialWidth: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SettlementAgent'),
            colId: 'settlementAgentId',
            field: 'settlementAgentId',
            initialWidth: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('SeaExport.ContractStatus'),
            field: 'contractStatus',
            width: 110,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.contractStatusLabFun(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
            field: 'userDefinedRoleId1',
            colId: 'userDefinedRoleId1',
            width: 150,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
            field: 'userDefinedRoleId2',
            colId: 'userDefinedRoleId2',
            width: 150,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }, { headerName: 'ETD',
            colId: 'jobEtd',
            field: 'jobEtd',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: 'ETA',
            colId: 'jobEta',
            field: 'jobEta',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: 'ATD',
            colId: 'jobAtd',
            field: 'jobAtd',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          }, {
            headerName: 'ATA',
            colId: 'jobAta',
            field: 'jobAta',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
            field: 'khPlateNumber',
            colId: 'khPlateNumber',
            width: 120,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
            field: 'khTrailerNumber',
            colId: 'khTrailerNumber',
            width: 120,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ExpenseBoxNo'),
            field: 'relationContainerNo',
            initialWidth: 200,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('SeaExport.ProjectName'),
            field: 'jobProjectName',
            colId: 'jobProjectName',
            hide: true,
            enableRowGroup: true,
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
            colId: 'cooperatebranch',
            field: 'cooperatebranch',
            width: 160, minWidth: 160,
            enableRowGroup: true,
            hide: !this.useOrderCenterMode
          }, {
            headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
            colId: 'cooperateBusinessType',
            field: 'cooperateBusinessType',
            width: 200, minWidth: 200,
            enableRowGroup: true,
            hide: !this.useOrderCenterMode
          }, {
            headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'),
            colId: 'rate',
            field: 'rate',
            width: 100, minWidth: 100,
            enableRowGroup: true,
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'jobCarrierId', width: 180, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
            field: 'jobDispatchingPlace',
            colId: 'jobDispatchingPlace',
            width: 120,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
            field: 'actTakeTime',
            colId: 'actTakeTime',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.BusinessStatus'),
            field: 'jobState',
            colId: 'jobState',
            cellRenderer: (params) => {
              return ColumnUtils.getJobStateCN(Number(params.value))
            },
            width: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
            field: 'approvalStatus',
            width: 100,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.approvalStatusLabelFun(Number(params.value))
            },
            hide: true
          }, { headerName: this.$t('Billing.Billing_Requirements'),
            field: 'invoiceDemand',
            width: 200,
            enableRowGroup: true,
            tooltip: (params) => {
              return params.data.invoiceDemand
            },
            hide: true
          }, { headerName: this.$t('SeaExport.ConsignationRelationNumber'),
            field: 'trustFromJob',
            width: 180,
            enableRowGroup: true,
            colId: 'trustFromJob',
            hide: true
          }, { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
            field: 'relatedJob',
            width: 180,
            colId: 'relatedJob',
            hide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
            field: 'salesOffice',
            colId: 'salesOffice',
            hide: true,
            width: 200,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
            field: 'opOffice',
            colId: 'opOffice',
            hide: true,
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('FinanceManage.CostType'),
            colId: 'costControlType',
            field: 'costControlType',
            width: 120,
            valueFormatter: (params) => {
              const isZh = $store.getters.language === 'zh'
              return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Billing.billingJob_markDate'), field: 'marksDate', width: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_markUser'), field: 'marksUser', width: 200, hide: true, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingJob_markStatus'), field: 'marks', width: 200, enableRowGroup: true, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.markingStateLabelFun(stringToBool(params.value))
            }
          }
        ],
        rowData: []
      },
      billingJobGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountBillingJobGrid
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true, pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Billing.billingJob_businessNumber'), field: 'jobNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: true,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.branchId)
                  },
                  printMethod: this.toSearchTemplate
                }
              }
            },
            width: 150,
            enableRowGroup: true
          },
          { headerName: this.$t('Billing.billingJob_settleAccountsTo'), field: 'accountId',
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
            }, width: 180, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_mblNo'), field: 'mbl', width: 130, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'hblNb3', width: 130, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_invoiceHeader'), field: 'invoiceTitle', width: 150, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_customer'), field: 'customerId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }, width: 150, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_carrier'), field: 'carrierId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }, width: 150, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_vessel'), field: 'vessel', width: 150, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_voyage'), field: 'voyageFlight', width: 100, enableRowGroup: true },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', initialWidth: 120,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            hide: true, enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', colId: 'siteOp', initialWidth: 120,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            hide: true, enableRowGroup: true
          },
          { headerName: this.$t('Billing.billingJob_portOfDischarge'), field: 'dischargingPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.lob === 'SE' || params.data.lob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.lob === 'AE' || params.data.lob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.lob === 'RE' || params.data.lob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            filter: false,
            filterParams: {},
            width: 120
          },
          { headerName: this.$t('Billing.billingJob_businessReferenceNumber'), field: 'customerRefNo', width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_warehouseNo'), field: 'warehouseNo', width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_bookingNo'), field: 'bookingNo', width: 100, enableRowGroup: true },
          { headerName: this.$t('CargoMsg.Cargo_ETD'), field: 'etd',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 120,
            enableRowGroup: true
          },
          { headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'eta', hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 120,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ATD'), field: 'atd',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 120,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ATA'), field: 'ata',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 120,
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.TaxNature'),
            field: 'taxNature',
            colId: 'taxNature',
            cellRenderer: params => {
              return ColumnUtils.taxNatureLabelFunction(params.value)
            },
            width: 120
          },
          { headerName: this.$t('Billing.billingJob_bookingAgent'), field: 'bookingAgent',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }, width: 130, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_operation'), field: 'op',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_customJobType'), field: 'customJobType',
            valueGetter: (params) => {
              return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', params.data.lob, params.data.fba)
            }, width: 130, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_sales'), field: 'sales',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_accrued'), field: 'isProvisioned',
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_businessType'), field: 'lob',
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_soNo'), field: 'soNo', width: 100, enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.soNoLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Partners.isFba'),
            colId: 'fba',
            field: 'fba',
            width: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }
          },
          {
            headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
            colId: 'warehouseCode',
            field: 'warehouseCode',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.DestinationDistribution'),
            colId: 'destinationDistribution',
            field: 'destinationDistribution',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
            }
          },
          {
            headerName: this.$t('FbaJob.ExpressNo'),
            colId: 'expressNo',
            field: 'expressNo',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.RemoteWarehouse'),
            colId: 'remoteWarehouse',
            field: 'remoteWarehouse',
            width: 180,
            hide: true,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }
          },
          {
            headerName: 'Shipment Id',
            colId: 'shipmentId',
            field: 'shipmentId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: 'Reference Id',
            colId: 'referenceId',
            field: 'referenceId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'isAr',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_currency'), field: 'chargeCurrency', width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_chargesTotalAmount'), field: 'chargeAmountTotal',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_reconciliationAmount'), field: 'billingAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_difference'), field: 'differenceAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_confirmState'), field: 'confirmState',
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_drawABbillOrNot'), field: 'isNeedInvoice',
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_invoicingMethod'), field: 'cdInvoiceMode',
            cellRenderer: (params) => {
              return ColumnUtils.invoiceModeLableFun(Number(params.value))
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_userDefinedField1'), field: 'userDefinedField1', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_userDefinedField2'), field: 'userDefinedField2', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_userDefinedField3'), field: 'userDefinedField3', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_userDefinedField4'), field: 'userDefinedField4', hide: true, width: 120, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_bargeETD'), field: 'bargeETD',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120, enableRowGroup: true },
          { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }, width: 100, enableRowGroup: true },
          {
            headerName: this.$t('Billing.billingCharge_businessDate'), field: 'businessDate', hide: true, width: 180, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'), field: 'receivableChargeLockedStatus', hide: true,
            cellRenderer: (params) => {
              const state = ChargeConstants.getCommonState(Number(params.value), ChargeConstants.CHARGE_LOCKED_STATES)
              return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
            }, width: 100, enableRowGroup: true },
          { headerName: this.$t('SeaExport.PayableChargeLockedStatus'), field: 'payableChargeLockedStatus', hide: true, width: 100, enableRowGroup: true,
            cellRenderer: (params) => {
              const state = ChargeConstants.getCommonState(Number(params.value), ChargeConstants.CHARGE_LOCKED_STATES)
              return state === null ? $store.getters.language === 'zh' ? '状态未知' : 'Status unknown' : $store.getters.language === 'zh' ? state.chineseName : state.englishName
            } },
          {
            headerName: this.$t('SeaExport.ContractStatus'),
            field: 'contractStatus',
            width: 110,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.contractStatusLabFun(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
            field: 'userDefinedRoleId1',
            colId: 'userDefinedRoleId1',
            width: 150,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
            field: 'userDefinedRoleId2',
            colId: 'userDefinedRoleId2',
            width: 150,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
            field: 'khPlateNumber',
            colId: 'khPlateNumber',
            width: 120,
            hide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
            field: 'khTrailerNumber',
            colId: 'khTrailerNumber',
            width: 120,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
            colId: 'cooperatebranch',
            field: 'cooperatebranch',
            width: 160, minWidth: 160,
            hide: !this.useOrderCenterMode,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
            colId: 'cooperateBusinessType',
            field: 'cooperateBusinessType',
            width: 200, minWidth: 200,
            hide: !this.useOrderCenterMode,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
            field: 'jobDispatchingPlace',
            colId: 'jobDispatchingPlace',
            width: 120,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
            field: 'actTakeTime',
            colId: 'actTakeTime',
            width: 120,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.BusinessStatus'),
            field: 'jobState',
            colId: 'jobState',
            cellRenderer: (params) => {
              return ColumnUtils.getJobStateCN(Number(params.value))
            },
            width: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
            field: 'approvalStatus',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.approvalStatusLabelFun(Number(params.value))
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.CostType'),
            colId: 'costControlType',
            field: 'costControlType',
            width: 120,
            valueFormatter: (params) => {
              const isZh = $store.getters.language === 'zh'
              return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Billing.billingJob_markDate'), field: 'marksDate', width: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('Billing.billingJob_markUser'), field: 'marksUser', width: 200, hide: true, enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingJob_markStatus'), field: 'marks', width: 200, enableRowGroup: true, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.markingStateLabelFun(stringToBool(params.value))
            }
          }
        ],
        rowData: []
      },
      billingGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountBillingGrid
        },
        rowData: []
      },
      billingGroupGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountBillingGroupGrid
        },
        rowData: []
      },
      // 对冲开票(相同columnDefs)
      searchConditionsHedge: {
        total: 0,
        totalChargeGrid: 0, // 按费用红冲
        totalBillingJobGrid: 0, // 按业务红冲
        totalBillingGrid: 0, // 按账单红冲
        totalBillingGroupGrid: 0, // 按对账单红冲
        pageNum: 1,
        pageNumChargeGrid: 1, // 按费用
        pageNumBillingJobGrid: 1, // 按业务
        pageNumBillingGrid: 1, // 按账单
        pageNumBillingGroupGrid: 1, // 按对账单
        pageSize: 20,
        likeName: '',
        paymentType: 1, // 收付方式，是否应收
        chargeTypeGroup: 0, // 费用类型，是否国外
        businessDateSearch: [], // 业务日期
        isNeedInvoice: 1, // 是否需要开票
        commission: 0, // 是否佣金
        advance: 0, // 是否垫付
        shared: 0, // 是否分摊费用
        paidOff: -1, // 是否销账
        hasInvoice: 0, // 是否开票
        hasBilling: -1, // 是否关联账单
        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        snapshotConditionsCharge: [], // 高级查询条件（点击查询时的快照状态）
        requiresCharge: [],
        snapshotConditionsJob: [],
        requiresChargeJob: [],
        billingHasPaidOff: '0', // 对账-费用-是否已核销(对账) 0.否 1.是
        billingHasBilling: '0', // 对账-费用-是否已生成账单(对账) 0.否 1.是
        billingHasBillPayment: '0', // 对账-费用-是否已申请付款(对账) 0.否 1.是
        allowInvoiceQueryAll: false, // 开票界面是否允许查询全部 0.不允许 1.允许
        createOverseaCharge: false, // 是否允许国外费用开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [],
        chargeStates: [],
        confirmStates: [],
        exceptKeys: [],
        accountId: 0, // 对冲开票结算单位
        billingJobStates: [], // 账单-业务状态
        billingStates: [], // 账单-账单状态
        billingClearingStates: [], // 账单-核销状态
        billingStateParam: 'InvoiceBillingState',
        billingClearingStateParam: 'InvoiceClearingState',
        billingJobStateParam: 'InvoiceJobState',
        billingRequires: ['writeoff', 'invoice', 'invoiceNo'],
        billingClearingState: -1, // 核销状态（0:有未销账,1:有已销账）
        selectedEntitiesForHedging: [],
        billingGroupStates: [], // 对账单状态
        billingGroupJobStates: [], // 对账单业务状态
        billingGroupJobStateParam: 'InvoiceJobState',
        billingGroupRequires: ['writeoff', 'invoice'],
        billingGroupClearingState: -1, // 核销状态（0:有未销账,1:有已销账）
        snapshotConditionsBilling: [],
        snapshotConditionsBillingGroup: [],
        internalCharge: false // 内结
      },
      chargeGridHedge: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGridHedge
        },
        rowData: []
      },
      billingJobGridHedge: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountBillingJobGridHedge
        },
        rowData: []
      },
      billingGridHedge: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountBillingGridHedge
        },
        rowData: []
      },
      billingGroupGridHedge: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountBillingGroupGridHedge
        },
        rowData: []
      },
      // 右下角合计详情小弹窗
      totalDetailDialog: {
        visible: false,
        data: [
          {
            currency: this.$t('Payment.amountNotWrittenOff'),
            chinese: '10',
            hkd: '10'
          },
          {
            currency: this.$t('Clearing.WrittenOffAmount'),
            chinese: '90',
            hkd: '90'
          },
          {
            currency: this.$t('Message.Receivable'),
            chinese: '100',
            hkd: '99'
          },
          {
            currency: this.$t('Message.Payable'),
            chinese: '100',
            hkd: '99'
          },
          {
            currency: this.$t('Clearing.Total'),
            chinese: '0',
            hkd: '0'
          }
        ]
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      // 开票/收票弹窗页
      makeInvoiceDialog: {
        visible: false,
        params: {}
      },
      makeInvoiceStepTwoDialog: {
        visible: false,
        title: '新增',
        params: {}
      },
      currentBillingBranchId: 0, // 账单所属分公司
      step: '', // step1=makeInvoiceStepOneDialog ; step2=makeInvoiceStepTwoDialog ; step3=makeInvoiceDialog
      // 生成发票
      properties: {

        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: true, // 是否应收

        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单

        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票、title=按抬头开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 1, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种

        billingRateMap: {}, // 账单币种、账单汇率
        isGenCostInvoice: false, // 生成成本发票开关已移除，固定为 false
        costInvoiceProp: {},

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选最大金额
        autoCheckInvoiceAmountEnable: false, // 自动勾选最大金额是否可用
        specificConstraintType: '', // 特定约束类型
        settlementCenterMode: false, // 锦昶共享中心
        rbgShowChargeDetail: '', // 显示明细
        apInvoiceCreateMusthaveTitileAndNumber: false, // 应付发票创建必须填写发票号和开票抬头
        unInvoiceCreate: false
      },
      // 生成成本发票
      costInvoiceProp: {
        mode: 'multi',
        invoiceType: 4, // 开票类型: 4=内部发票
        groupingCurrencyType: 4
      },
      chargeMap: {

      },
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      customSearchItemsHedge: [],
      defaultSearchItemsHedge: [],
      searchItemAutoInitHedge: true,
      normalSearchItemConfigs: [
        { searchItemCode: '按费用查询', configModule: '5021', simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'), gridConfigModule: '190601' },
        { searchItemCode: '按业务查询', configModule: '5022', simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'), gridConfigModule: '190602' },
        { searchItemCode: '按账单查询', configModule: '504', simQueryPlaceholder: this.$t('Clearing.QuickSearchBillNumber'), gridConfigModule: '190603' },
        { searchItemCode: '按对账单查询', configModule: '505', simQueryPlaceholder: this.$t('Clearing.QuickSearchReconciliationBillNumber'), gridConfigModule: '190604' }
      ],
      hedgeSearchItemConfigs: [
        { searchItemCode: '按费用查询(红冲)', configModule: '50211', simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'), gridConfigModule: '1906012' },
        { searchItemCode: '按业务查询(红冲)', configModule: '50221', simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'), gridConfigModule: '1906022' },
        { searchItemCode: '按账单查询(红冲)', configModule: '504', simQueryPlaceholder: this.$t('Clearing.QuickSearchBillNumber'), gridConfigModule: '1906032' },
        { searchItemCode: '按对账单查询(红冲)', configModule: '505', simQueryPlaceholder: this.$t('Clearing.QuickSearchReconciliationBillNumber'), gridConfigModule: '1906042' }
      ],
      totalAmountToCurrencyChargeGrid: { // 右下角合计组件相关参数：按费用
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Invoice.invoice_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Clearing.TotalExcludingTax'),
            'excludingTaxAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Clearing.TotalIncludingTax'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isReceivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      totalAmountToCurrencyBillingJobGrid: { // 右下角合计组件相关参数：按业务
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'chargeAmountTotal', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'chargeAmountTotal', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'chargeAmountTotal', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingJob_reconciliationAmount'),
            'billingAmount', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingJob_difference'),
            'differenceAmount', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'chargeAmountTotal', 'chargeCurrency', 'chargeExchangeRate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      totalAmountToCurrencyBillingGrid: { // 右下角合计组件相关参数：按账单
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      totalAmountToCurrencyBillingGroupGrid: { // 右下角合计组件相关参数：按对账单
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      totalAmountToCurrencyChargeGridHedge: { // 右下角合计组件相关参数：按费用红冲
        selectedCount: 0,
        dataProvider: [] // 数据源
      },
      totalAmountToCurrencyBillingJobGridHedge: { // 右下角合计组件相关参数：按业务红冲
        selectedCount: 0,
        dataProvider: [] // 数据源
      },
      totalAmountToCurrencyBillingGridHedge: { // 右下角合计组件相关参数：按账单红冲
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      totalAmountToCurrencyBillingGroupGridHedge: { // 右下角合计组件相关参数：按对账单红冲
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      viewSource: 'tabMakeInvoice', // 记录页面请求方
      showLoading: true, // 是否显示加载中状态
      tabBillingHp: new TabBillingHp(this),
      tabBillingGroupHp: new TabBillingGroupHp(this),
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 1, // 开票方式
        makeInvoiceMethodHedge: 1, // 开票方式
        useAutoCheckInvoicing: false,
        autoCheckInvoiceAmountEnable: false,
        autoCheckInvoicingAmount: 0.00,
        isInvoiceByEachBillingRate: false // isInvoiceByEachBillingRate：是否按各自账单汇率来开票
      },
      signBillingDialog: { // 标记账单
        billingKeys: [],
        visible: false
      },
      signChargeDialog: { // 标记费用
        keys: [],
        visible: false
      },
      signBusinessDialog: { // 标记业务
        keys: [],
        visible: false
      },
      showColumnsVisible: { // 控制显示列是否隐藏
        showVoucherDate: true,
        showInvoiceState: false,
        showRealClearingState: false,
        showVerifiedAmount: false,
        showFba: false, // 显示FBA相关列
        showUnInvoiceAmount: false
      },
      shouldFixed: false,
      gridApi: null,
      queryOfficeId: 0, // 记录查询时的分公司Id
      queryOfficeIdHedge: 0,
      autoCheckInvoiceDialog: { // 自动勾选开票金额弹出框
        visible: false,
        amount: 0,
        selectKeys: []
      },
      invoicePoolDialog: {
        visible: false,
        sellerTaxNameDefaultValue: '',
        selectedEntities: [],
        operation: '',
        source: 'invoice',
        makeInvoiceMethod: 1
      },
      location: LOG_MAKE_INVOICE.code,
      hmToFinanceApi: false
    }
  },
  computed: {
    makeInvoiceBtnText() {
      const type = this.searchConditions.paymentType
      // const makeInvoiceBtn = type === 0 ? '收票' : '开票'
      const makeInvoiceBtn = type === 0 ? this.$t('Invoice.invoice_collectInvoice') : this.$t('Invoice.invoice_invoicing')
      // const hedgeMakeInvoiceBtn = type === 0 ? '对冲收票' : '对冲开票'
      const hedgeMakeInvoiceBtn = type === 0 ? this.$t('Invoice.invoice_hedgingCollectingInvoice') : this.$t('Invoice.invoice_hedgingInvoice')
      // const hedgeMakeInvoiceLabel = this.properties.isAr ? '对冲开票：请查询并选择要对冲的应付费用' : '对冲收票：请查询并选择要对冲的应收费用'
      const hedgeMakeInvoiceLabel = this.properties.isAr ? this.$t('Invoice.invoice_hedging') + this.$t('CargoMsg.Cargo_Invoicing') + ': ' + this.$t('Invoice.invoice_selectTheHedging') + this.$t('CargoMsg.Cargo_Dues') + this.$t('CargoMsg.Cargo_Cost')
        : this.$t('Invoice.invoice_hedging') + this.$t('CargoMsg.Cargo_CollectInvoice') + ': ' + this.$t('Invoice.invoice_selectTheHedging') + this.$t('CargoMsg.Cargo_Receivable') + this.$t('CargoMsg.Cargo_Cost')
      return { makeInvoiceBtn, hedgeMakeInvoiceBtn, hedgeMakeInvoiceLabel }
    },
    totalDetailExpandClass() {
      return { 'el-icon-d-arrow-left': this.totalDetailDialog.visible, 'el-icon-d-arrow-right': !this.totalDetailDialog.visible, 'el-icon--right': true }
    },
    // 标题
    title() {
      if (this.properties.isHedge) {
        return this.$t('Invoice.invoice_hedgingInvoice')
      } else {
        return this.properties.isAr ? this.$t('Billing.billing_drawInvoice') : this.$t('Billing.billing_collectInvoice')
      }
    },
    dynamicColumnDefs() {
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      if (searchConditions.makeInvoiceMethod === 3) {
        const result = this.tabBillingHp.dynamicColumnDefs()
        result.push({ headerName: this.$t('Invoice.invoice_containerNo'), field: 'jobContainerNo', hide: true, width: 120, enableRowGroup: true,
          valueFormatter: (params) => {
            return params.value ? params.value.split(',').filter(p => p).join(',') : params.value
          }
        })
        result.push({
          headerName: this.$t('SeaExport.BusinessStatus'),
          field: 'jobState',
          colId: 'jobState',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateCN(Number(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementType',
          initialWidth: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypeLableFun(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return this.taxNatureLabelFunction(params.value)
          },
          width: 120
        })
        return result
      } else if (searchConditions.makeInvoiceMethod === 4) {
        const result = this.tabBillingGroupHp.dynamicColumnDefs()
        result.push({
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return this.taxNatureLabelFunction(params.value)
          },
          width: 120
        })
        return result
      }
      return []
    },
    inputDateLabel() {
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      switch (searchConditions.makeInvoiceMethod) {
        case 1:
        case 2: return this.$t('Invoice.invoice_businessDate')
          break
        case 3:
        case 4: return this.$t('Billing.billingJob_billDate')
          break
      }
    },
    getConfirmMsg() {
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      switch (searchConditions.makeInvoiceMethod) {
        case 1:
        case 2: return this.$t('Invoice.invoice_unlockBusinessDateQuery')
          break
        case 3:
        case 4: return this.$t('Billing.billingJob_unlockInputDateQuery')
          break
      }
    },
    initCustomSearchItemsHedge() {
      console.log('accountId', this.searchConditionsHedge.accountId)
      const defaultSearchFields = []
      if (this.pageMode === 1 && this.searchConditionsHedge.accountId) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.searchConditionsHedge.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.searchConditionsHedge.accountId
          if (this.searchConditionsHedge.makeInvoiceMethod === 3) { // 账单
            searchField.itemLabel = 'Billing.billingJob_settlementCompany'
            searchField.itemName = 'billing.ACCOUNTID'
          } else if (this.searchConditionsHedge.makeInvoiceMethod === 4) { // 对账单
            searchField.itemLabel = 'Billing.billingJob_settlementCompany'
            searchField.itemName = 'billingGroup.ACCOUNT_ID'
          } else {
            searchField.itemLabel = 'Invoice.invoice_settlementCompany'
            searchField.itemName = 'charge.ACCOUNT_ID'
          }
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItemsHedge, defaultSearchFields)
      }
      // if (defaultSearchFields.length > 0) {
      this.customSearchItemsHedge = defaultSearchFields
      this.searchItemAutoInitHedge = true
      // }
      return this.customSearchItemsHedge
    },
    btnMakeInvoice() { // 开票/收票按钮权限
      return this.$checkPermission(['button_ACMakeInvoice_invoice'])
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    },
    gridOptions() {
      if (this.pageMode === 0) {
        switch (this.searchConditions.makeInvoiceMethod) {
          case 1:
            return this.chargeGrid.gridOptions
          case 2:
            return this.billingJobGrid.gridOptions
          case 3:
            return this.billingGrid.gridOptions
          case 4:
            return this.billingGroupGrid.gridOptions
        }
      }
      if (this.pageMode === 1) {
        switch (this.searchConditions.makeInvoiceMethod) {
          case 1:
            return this.chargeGridHedge.gridOptions
          case 2:
            return this.billingJobGridHedge.gridOptions
          case 3:
            return this.billingGridHedge.gridOptions
          case 4:
            return this.billingGroupGridHedge.gridOptions
        }
      }
      return {}
    }
  },
  watch: {
    async isShow(newVal) {
      if (newVal) {
        // 刷新时默认页签没变，不会重新加载。恢复到created
        // await cache.load(cacheName.CONFIG)
        // // 配置参数
        // this.initConfig()
      }
    },
    allowTwoYearOutside(val) {
      if (val) {
        let msg = this.getConfirmMsg
        if (StrUtils.isEmpty(msg)) {
          msg = '若选的日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？'
        }
        this.$confirm(msg, this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(() => {
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        await this.initCustomSearchItems()
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
  },
  async created() {
    try {
      await existWorkflowGroup({
        officeId: this.$store.getters.currentOfficeId,
        formSubtype: MAKE_INVOICE_INTERNAL_INVOICE.code
      }).then(async res => {
        this.properties.invoiceTriggerBpm = res.data
      })
    } catch (e) {
      // error
    }
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    this.initializeSetting()
    const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
    if (searchConditions.makeInvoiceMethod === 1) {
      await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
      await this.initCustomSearchItems()
    } else if (searchConditions.makeInvoiceMethod === 3) {
      await this.tabBillingHp.changeCustomSearchItems()
    } else if (searchConditions.makeInvoiceMethod === 4) {
      await this.tabBillingGroupHp.changeCustomSearchItems()
    }
    this.setLocalCurrency()
  },
  mounted() {
    this.scrollCallback()
    document.querySelector('.makeInvoice').addEventListener('scroll', this.scrollCallback)
  },
  methods: {
    handleStepVisibleChange(step, visible) {
      if (!visible && this.step === step) {
        this.toStepHandler('')
      }
    },
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 配置参数
    async initConfig() {
      this.searchConditions.billingHasPaidOff = String(cache.config.get('BillingHasPaidOff'))
      this.searchConditions.billingHasBilling = String(cache.config.get('BillingHasBilling'))
      this.searchConditions.billingHasBillPayment = String(cache.config.get('BillingHasBillPayment'))
      this.searchConditions.allowInvoiceQueryAll = Number(cache.config.get('AllowInvoiceQueryAll')) === 1
      this.searchConditions.createOverseaCharge = Number(cache.config.get('CreateInvoiceByOverseaCharge')) === 1
      this.searchConditions.invoiceReceiveChargeState = String(cache.config.get('InvoiceReceiveChargeState'))
      this.searchConditions.invoicePayChargeState = String(cache.config.get('InvoicePayChargeState'))
      this.searchConditions.jobStateParam = String(cache.config.get('InvoiceJobState'))
      this.searchConditions.chargeStateParam = String(cache.config.get('InvoiceChargeState'))
      this.searchConditions.confirmStateParam = String(cache.config.get('InvoiceChargeConfirmState'))
      this.searchConditions.jobStateParam2 = String(cache.config.get('BillingJobState'))
      this.searchConditions.chargeStateParam2 = String(cache.config.get('BillingChargeState'))
      this.searchConditions.confirmStateParam2 = String(cache.config.get('BillingChargeConfirmState'))
      this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      //
      const jobStates = []
      this.searchConditions.jobStateParam.split(',').forEach(function(value) {
        jobStates.push(Number(value))
      })
      this.searchConditions.jobStates = jobStates
      //
      const chargeStates = []
      this.searchConditions.chargeStateParam.split(',').forEach(function(value) {
        chargeStates.push(Number(value))
      })
      this.searchConditions.chargeStates = chargeStates
      //
      const confirmStates = []
      this.searchConditions.confirmStateParam.split(',').forEach(function(value) {
        confirmStates.push(Number(value))
      })
      this.searchConditions.confirmStates = confirmStates
      //
      const jobStates2 = []
      this.searchConditions.jobStateParam2.split(',').forEach(function(value) {
        jobStates2.push(Number(value))
      })
      this.searchConditions.jobStates2 = jobStates2
      //
      const chargeStates2 = []
      this.searchConditions.chargeStateParam2.split(',').forEach(function(value) {
        chargeStates2.push(Number(value))
      })
      this.searchConditions.chargeStates2 = chargeStates2
      //
      const confirmStates2 = []
      this.searchConditions.confirmStateParam2.split(',').forEach(function(value) {
        confirmStates2.push(Number(value))
      })
      this.searchConditions.confirmStates2 = confirmStates2
      //
      this.searchConditionsHedge.billingHasPaidOff = this.searchConditions.billingHasPaidOff
      this.searchConditionsHedge.billingHasBilling = this.searchConditions.billingHasBilling
      this.searchConditionsHedge.billingHasBillPayment = this.searchConditions.billingHasBillPayment
      this.searchConditionsHedge.allowInvoiceQueryAll = this.searchConditions.allowInvoiceQueryAll
      this.searchConditionsHedge.createOverseaCharge = this.searchConditions.createOverseaCharge
      this.properties.invoiceItemGoodsName = Number(cache.config.get('InvoiceItemGoodsName'))
      this.properties.defaultGoodsName = String(cache.config.get('InvoiceMergeName'))
      this.properties.showChargeDetailByInvoice = String(cache.config.get('ShowChargeDetailByInvoice')) === '1'
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.costInfo = Number(cache.config.get('costSplitInfo')) === 1
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.isInvoiceByEachBillingRate = Number(cache.config.get('isInvoiceByEachBillingRate')) === 1
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
      this.properties.apInvoiceCreateMusthaveTitileAndNumber = String(cache.config.get('APInvoiceCreateMusthaveTitileAndNumber')) === '1' // 备注:应付发票创建必须填写发票号和开票抬头，如果未填写则发票不会保存。
    },
    // 从缓存里面加载开票选项
    initializeSetting() {
      const makeInvoiceSaveCache = 'Make_Invoice_Save_Cache'
      const setting = LocalStorageUtilsNew.getConfiguration(makeInvoiceSaveCache)
      if (setting) {
        this.searchConditions.paymentType = setting.paymentType
        this.initCustomSearchItems()
        this.searchConditions.chargeTypeGroup = setting.chargeTypeGroup
        this.searchConditions.makeInvoiceMethod = setting.makeInvoiceMethod
        this.makeInvoiceMethodChange()
      }
      this.setPaymentType()
    },
    setPaymentType() {
      // 已分配【应收】【应付】：默认查【应收】
      // 已分配【应付】未分配【应收】：默认查【应付】
      // 均未分配【应收】【应付】：默认查【全部】（根据参数判断是否可以查全部，未开启情况下不做查询，主动查询也无法查询出数据）
      if (!this.$checkPermission(['button_tabMakeInvoice_arCharge']) && !this.$checkPermission(['button_tabMakeInvoice_apCharge'])) {
        if (!this.searchConditions.allowInvoiceQueryAll) {
          this.searchConditions.paymentType = 2
          this.searchConditionsHedge.paymentType = 2
        } else {
          this.searchConditions.paymentType = -1
          this.searchConditionsHedge.paymentType = -1
        }
      } else if (!this.$checkPermission(['button_tabMakeInvoice_arCharge']) && this.$checkPermission(['button_tabMakeInvoice_apCharge'])) {
        this.searchConditions.paymentType = 0
        this.searchConditionsHedge.paymentType = 0
      } else {
        this.searchConditions.paymentType = 1
        this.searchConditionsHedge.paymentType = 1
      }
    },
    // todo: 请注意，该页表格列根据搜索条件切换，获取gridOptions请使用this.getGridOptions()，赋值表格数据请单独加判断
    async fetchData(conditions, simpleTriggerMode = false) {
      if (simpleTriggerMode) { // 简单查询时不走高级查询条件
        this.appendQuery = false
      }
      await this.initConfig()
      // 开票/对冲开票
      console.log('pageMode', this.pageMode)
      if (this.pageMode === 1) {
        this.queryOfficeIdHedge = this.$store.getters.currentOfficeId
      } else {
        this.queryOfficeId = this.$store.getters.currentOfficeId
      }
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      // paymentType特殊处理，2表示没有分配查询应收、应付的权限, 且未开启开票界面查询全部的参数
      if (searchConditions.paymentType === 2) {
        return
      }
      switch (searchConditions.makeInvoiceMethod) {
        case 1: {
          searchConditions.pageNumChargeGrid = 1
          const finallyConditions = []
          // 高级查询条件组装
          // if (!simpleTriggerMode) {
          const advConditions = lodash.cloneDeep(conditions)
          // 内结
          if (searchConditions.internalCharge) {
            const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(condition.formatObj2Json())
          }
          if (searchConditions.paymentType !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', searchConditions.paymentType, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.commission !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.COMMISSION', searchConditions.commission, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.advance !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.ADVANCE', searchConditions.advance, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.isNeedInvoice !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', searchConditions.isNeedInvoice, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.shared !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.SHARED', searchConditions.shared, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.chargeTypeGroup > -1) {
            const option = new AdvancedSearchOption(null, 'charge.OVERSEA', searchConditions.chargeTypeGroup, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.paidOff > -1) {
            const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', searchConditions.paidOff, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', conditions)) {
            const option = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', '', (searchConditions.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.hasBilling !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.BILLING_UUID', '', (searchConditions.hasBilling === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
            finallyConditions.push(option.formatObj2Json())
          }
          const option = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
          // 业务日期
          let inputDate = ''
          if (this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
            inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00' + ',end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
          } else if (!this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
            inputDate = 'end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
          } else if (this.searchConditions.inputDateStart && !this.searchConditions.inputDateEnd) {
            inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00'
          }
          if (inputDate) {
            const condition = new AdvancedSearchOption(null, 'charge.BUSINESS_DATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
            finallyConditions.push(condition.formatObj2Json())
          }
          // 默认
          if (this.searchConditions.jobStates.length > 0) {
            const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, OperatorConstants.OPERATOR_IN.code)
            finallyConditions.push(option.formatObj2Json())
          }
          // if (this.searchConditions.chargeStates.length > 0) {
          //   const option = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', this.searchConditions.chargeStates, OperatorConstants.OPERATOR_IN.code)
          //   finallyConditions.push(option.formatObj2Json())
          // }
          // 参照QueryCharge.chargeStateConditionCharge
          const chargeStates = []
          if (this.searchConditions.paymentType === -1) {
            // 两个配置参数都开启,费用状态显示栏位取两者并集
            if (this.searchConditions.invoiceReceiveChargeState) {
              this.searchConditions.invoiceReceiveChargeState.split(',').forEach(function(value) {
                if (chargeStates.indexOf(Number(value)) === -1) {
                  chargeStates.push(Number(value))
                }
              })
            }
            if (this.searchConditions.invoicePayChargeState) {
              this.searchConditions.invoicePayChargeState.split(',').forEach(function(value) {
                if (chargeStates.indexOf(Number(value)) === -1) {
                  chargeStates.push(Number(value))
                }
              })
            }
          } else if (this.searchConditions.paymentType === 1) {
            this.searchConditions.invoiceReceiveChargeState.split(',').forEach(function(value) {
              chargeStates.push(Number(value))
            })
          } else {
            this.searchConditions.invoicePayChargeState.split(',').forEach(function(value) {
              chargeStates.push(Number(value))
            })
          }
          console.log('chargeStates-=-=----', chargeStates)
          // 费用状态
          if (chargeStates.length > 0) {
            if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
              const option = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
              finallyConditions.push(option.formatObj2Json())
            } else {
              const option = AdvancedSearchOption.getOption('charge.CHARGE_STATE', advConditions)
              const valueArray = option.value
              const chargeStateCondition = [-1]
              valueArray.forEach(function(value) {
                if (chargeStates.indexOf(value) !== -1) { // 当前范围内
                  chargeStateCondition.push(value)
                }
              })
              AdvancedSearchOption.removeOption('charge.CHARGE_STATE', advConditions)
              //
              const option1 = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStateCondition, OperatorConstants.OPERATOR_IN.code)
              finallyConditions.push(option1.formatObj2Json())
            }
          }
          if (this.searchConditions.confirmStates.length > 0) {
            const option = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', this.searchConditions.confirmStates, OperatorConstants.OPERATOR_IN.code)
            finallyConditions.push(option.formatObj2Json())
          }
          // CARGO-673巴士悦信：参数【InvoiceChargeState开票-费用-费用状态查询(发票)】分为应收、应付2种
          const chargeStateParam = new AdvancedSearchOption(null, 'chargeStateParam', 'InvoiceChargeState', OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(chargeStateParam.formatObj2Json())
          const invoiceReceiveChargeState = new AdvancedSearchOption(null, 'invoiceReceiveChargeState', this.searchConditions.invoiceReceiveChargeState, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(invoiceReceiveChargeState.formatObj2Json())
          const invoicePayChargeState = new AdvancedSearchOption(null, 'invoicePayChargeState', this.searchConditions.invoicePayChargeState, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(invoicePayChargeState.formatObj2Json())
          // 获取追加查询条件
          this.appendQuery = JobUtils.appendQueryCondition(advConditions)
          //
          finallyConditions.push(...advConditions)
          // } else {
          //   finallyConditions.push(...conditions)
          // }
          // 是否查询受控费用
          if (!this.showControlledCharge) {
            // 是否有应付受控费用权限
            const isControlled = this.$checkPermission(['button_Charge_controlled'])
            // 是否有应收受控费用权限
            const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
            let value = 0
            if (!isControlled && !isCostControlled) {
              value = 1
            } else if (!isControlled) {
              value = 2
            } else if (!isCostControlled) {
              value = 3
            }
            if (value !== 0) {
              const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
              finallyConditions.push(option.formatObj2Json())
            }
          }
          // 对冲开票
          if (this.pageMode === 1) {
            if (searchConditions.exceptKeys.length > 0) {
              const option = new AdvancedSearchOption(null, 'charge.UUID', searchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
              finallyConditions.push(option.formatObj2Json())
            }
            // 结算单位
            if (this.searchConditionsHedge.accountId > 0 && !AdvancedSearchOption.hasField('charge.ACCOUNT_ID', conditions)) {
              const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_ID', this.searchConditionsHedge.accountId, OperatorConstants.OPERATOR_EQUAL.code)
              finallyConditions.push(option.formatObj2Json())
            }
          }

          console.log(finallyConditions)
          // 条件保存
          searchConditions.snapshotConditionsCharge = finallyConditions
          this.toQueryChargeList()
        }
          // this.chargeGrid.rowData = rowData
          break
        case 2: {
          searchConditions.pageNumBillingJobGrid = 1
          const finallyConditions = []
          // 高级查询条件组装
          // if (!simpleTriggerMode) {
          const advConditions = lodash.cloneDeep(conditions)
          // 内结
          if (searchConditions.internalCharge) {
            const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(condition.formatObj2Json())
          }
          if (searchConditions.paymentType !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', searchConditions.paymentType, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.commission !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.COMMISSION', searchConditions.commission, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.advance !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.ADVANCE', searchConditions.advance, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.isNeedInvoice !== -1) {
            const option = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', searchConditions.isNeedInvoice, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.chargeTypeGroup > -1) {
            const option = new AdvancedSearchOption(null, 'charge.OVERSEA', searchConditions.chargeTypeGroup, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          const option = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())

          if (searchConditions.billingHasPaidOff === '1' || searchConditions.billingHasPaidOff === '0') {
            const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', Number(searchConditions.billingHasPaidOff), OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.billingHasBilling === '1' || searchConditions.billingHasBilling === '0') {
            const option = new AdvancedSearchOption(null, 'charge.BILLING_UUID', '', searchConditions.billingHasBilling === '0' ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.billingHasBillPayment === '1' || searchConditions.billingHasBillPayment === '0') {
            const option = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', '', searchConditions.billingHasBillPayment === '0' ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', conditions)) {
            const option = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', '', (searchConditions.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
            finallyConditions.push(option.formatObj2Json())
          }
          if (searchConditions.hasDiffCharge !== -1 && !AdvancedSearchOption.hasField('charge.DIFF_CHARGE_UUID', conditions)) {
            const option = new AdvancedSearchOption(null, 'charge.DIFF_CHARGE_UUID', '', (searchConditions.hasDiffCharge === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
            finallyConditions.push(option.formatObj2Json())
          }
          // 默认
          if (this.searchConditions.jobStates2.length > 0) {
            const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates2, OperatorConstants.OPERATOR_IN.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (this.searchConditions.chargeStates2.length > 0) {
            const option = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', this.searchConditions.chargeStates2, OperatorConstants.OPERATOR_IN.code)
            finallyConditions.push(option.formatObj2Json())
          }
          if (this.searchConditions.confirmStates2.length > 0) {
            const option = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', this.searchConditions.confirmStates2, OperatorConstants.OPERATOR_IN.code)
            finallyConditions.push(option.formatObj2Json())
          }
          // 业务日期
          let inputDate = ''
          if (this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
            inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00' + ',end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
          } else if (!this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
            inputDate = 'end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
          } else if (this.searchConditions.inputDateStart && !this.searchConditions.inputDateEnd) {
            inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00'
          }
          if (inputDate) {
            const condition = new AdvancedSearchOption(null, 'job.BUSINESS_DATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
            finallyConditions.push(condition.formatObj2Json())
          }
          // 获取追加查询条件
          this.appendQuery = JobUtils.appendQueryCondition(advConditions)
          //
          finallyConditions.push(...advConditions)
          // } else {
          //   finallyConditions.push(...conditions)
          // }
          // 对冲开票
          if (this.pageMode === 1) {
            if (searchConditions.exceptKeys.length > 0) {
              const option = new AdvancedSearchOption(null, 'charge.UUID', searchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
              finallyConditions.push(option.formatObj2Json())
            }
            // 结算单位
            if (this.searchConditionsHedge.accountId > 0 && !AdvancedSearchOption.hasField('charge.ACCOUNT_ID', conditions)) {
              const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_ID', this.searchConditionsHedge.accountId, OperatorConstants.OPERATOR_EQUAL.code)
              finallyConditions.push(option.formatObj2Json())
            }
          }
          // 是否查询受控费用
          if (!this.showControlledCharge) {
            // 是否有应付受控费用权限
            const isControlled = this.$checkPermission(['button_Charge_controlled'])
            // 是否有应收受控费用权限
            const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
            let value = 0
            if (!isControlled && !isCostControlled) {
              value = 1
            } else if (!isControlled) {
              value = 2
            } else if (!isCostControlled) {
              value = 3
            }
            if (value !== 0) {
              const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
              finallyConditions.push(option.formatObj2Json())
            }
          }

          console.log(finallyConditions)
          // 条件保存
          searchConditions.snapshotConditionsJob = finallyConditions
          this.toQueryChargeJobList()
        }
          break
        case 3:
          searchConditions.pageNumBillingGrid = 1
          // 是否查询受控费用
          if (!this.showControlledCharge) {
            // 是否有应付受控费用权限
            const isControlled = this.$checkPermission(['button_Charge_controlled'])
            // 是否有应收受控费用权限
            const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
            let value = 0
            if (!isControlled && !isCostControlled) {
              value = 1
            } else if (!isControlled) {
              value = 2
            } else if (!isCostControlled) {
              value = 3
            }
            if (value !== 0) {
              const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
              conditions.push(option.formatObj2Json())
            }
          }
          conditions.push(new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code).formatObj2Json())
          this.tabBillingHp.fetchData({ conditions, simpleTriggerMode })
          break
        case 4:
          searchConditions.pageNumBillingGroupGrid = 1
          // 是否查询受控费用
          if (!this.showControlledCharge) {
            // 是否有应付受控费用权限
            const isControlled = this.$checkPermission(['button_Charge_controlled'])
            // 是否有应收受控费用权限
            const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
            let value = 0
            if (!isControlled && !isCostControlled) {
              value = 1
            } else if (!isControlled) {
              value = 2
            } else if (!isCostControlled) {
              value = 3
            }
            if (value !== 0) {
              const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
              conditions.push(option.formatObj2Json())
            }
          }
          conditions.push(new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code).formatObj2Json())
          this.tabBillingGroupHp.fetchData({ conditions, simpleTriggerMode })
          break
      }
    },
    async fetchDataBykeyWord(keyWord) {
      this.searchConditions.pageNum = 1
      if (!StrUtils.isEmpty(keyWord)) {
        if (this.pageMode === 1) {
          this.queryOfficeIdHedge = this.$store.getters.currentOfficeId
        } else {
          this.queryOfficeId = this.$store.getters.currentOfficeId
        }
        const conditions = []
        const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
        // paymentType特殊处理，2表示没有分配查询应收、应付的权限, 且未开启开票界面查询全部的参数
        if (searchConditions.paymentType === 2) {
          return
        }
        switch (searchConditions.makeInvoiceMethod) {
          case 1: {
            this.searchConditions.pageNumChargeGrid = 1
            const option = new AdvancedSearchOption(null, 'job.JOB_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
            conditions.push(option.formatObj2Json())
          }
            break
          case 2: {
            this.searchConditions.pageNumBillingJobGrid = 1
            const option = new AdvancedSearchOption(null, 'job.JOB_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
            conditions.push(option.formatObj2Json())
          }
            break
          case 3: {
            searchConditions.pageNumBillingGrid = 1
            const option = new AdvancedSearchOption(null, 'billing.BILLINGNO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
            conditions.push(option.formatObj2Json())
            this.tabBillingHp.toAdvQueryList(conditions, true)
          }
            break
          case 4: {
            searchConditions.pageNumBillingGroupGrid = 1
            const option = new AdvancedSearchOption(null, 'billingGroup.BILLING_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
            conditions.push(option.formatObj2Json())
            this.tabBillingGroupHp.toAdvQueryList(conditions, true)
          }
            break
        }
        //
        if (conditions.length > 0 && [1, 2].includes(searchConditions.makeInvoiceMethod)) {
          await this.fetchData(conditions, true)
        }
      }
    },
    toQueryChargeList() {
      const { snapshotConditionsCharge: conditions, requiresCharge: requires, pageNumChargeGrid: pageNum, pageSize } = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      if (this.showColumnsVisible.showFba) { requires.push('fba') }
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, currentBillingBranchId: this.currentBillingBranchId, 'requestSource': 'Invoice' }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryChargeList(requestBody).then(res => {
        console.log('queryChargeList', res.data.list)
        let results = res.data.list
        if (this.pageMode === 0) {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.chargeGrid.rowData, results, this.appendQuery)
          }
          this.chargeGrid.rowData = results
          this.searchConditions.totalChargeGrid = this.appendQuery ? results.length : Number(res.data.total)
          //
          this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
          this.totalAmountToCurrencyChargeGrid.selectedCount = 0
        } else {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.chargeGridHedge.rowData, results, this.appendQuery)
          }
          this.chargeGridHedge.rowData = results
          this.searchConditionsHedge.totalChargeGrid = this.appendQuery ? results.length : Number(res.data.total)
          //
          this.totalAmountToCurrencyChargeGridHedge.dataProvider = this.chargeGridHedge.rowData
          this.totalAmountToCurrencyChargeGridHedge.selectedCount = 0
        }
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    toQueryChargeJobList() {
      const { snapshotConditionsJob: conditions, requiresJob: requires, pageNumBillingJobGrid: pageNum, pageSize } = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      if (this.showColumnsVisible.showFba) { requires.push('fba') }
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'requestSource': 'Invoice' }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryChargeJobList(requestBody).then(res => {
        console.log('queryChargeJobList', res.data.list)
        let results = res.data.list
        if (this.pageMode === 0) {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.billingJobGrid.rowData, results, this.appendQuery)
          }
          this.billingJobGrid.rowData = results
          this.searchConditions.totalBillingJobGrid = this.appendQuery ? results.length : Number(res.data.total)
          //
          let rowData = []
          if (res.data.list && res.data.list.length > 0) {
            rowData = this.getChargeDetailFotChargeJob(results)
          } else {
            rowData = results
          }
          this.totalAmountToCurrencyBillingJobGrid.dataProvider = rowData
          this.totalAmountToCurrencyBillingJobGrid.selectedCount = 0
        } else {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.billingJobGridHedge.rowData, results, this.appendQuery)
          }
          this.billingJobGridHedge.rowData = results
          this.searchConditionsHedge.totalBillingJobGrid = this.appendQuery ? results.length : Number(res.data.total)
          //
          this.totalAmountToCurrencyBillingJobGridHedge.dataProvider = this.billingJobGridHedge.rowData
          this.totalAmountToCurrencyBillingJobGridHedge.selectedCount = 0
        }
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 分页触发查询
    fetchDataByPage(param) {
      const makeInvoiceMethod = this.pageMode === 0 ? this.searchConditions.makeInvoiceMethod : this.searchConditionsHedge.makeInvoiceMethod
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      switch (makeInvoiceMethod) {
        case 1:
          this.toQueryChargeList()
          break
        case 2:
          this.toQueryChargeJobList()
          break
        case 3:
          this.showLoading = true
          this.tabBillingHp.toAdvQueryList(lodash.cloneDeep(searchConditions.snapshotConditionsBilling), false)
          break
        case 4:
          this.showLoading = true
          this.tabBillingGroupHp.toAdvQueryList(lodash.cloneDeep(searchConditions.snapshotConditionsBillingGroup), false)
          break
      }
    },
    // 开票/收票btn click event
    async toMakeInvoice() {
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      const makeInvoiceMethod = Number(searchConditions.makeInvoiceMethod)
      this.properties.selectedEntities = getGridSelected(this.getGridOptions())
      if (this.properties.selectedEntities.length === 0) {
        switch (makeInvoiceMethod) {
          case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
            break
          case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
            break
          case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
            break
          case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
            break
        }
        return
      }
      console.log('selectedEntities--------------', this.properties.selectedEntities)
      // CARGO-18111 根据账单开票，校验所选项中有账单状态为未确认的账单，提示账单未确认是否继续开票
      const existNotConfirm = this.properties.selectedEntities.filter(el => el.state === 0)
      if (makeInvoiceMethod === 3 && existNotConfirm.length) {
        await this.$confirm(this.$t('Invoice.existUnconfirmedStatus'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        })
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.gridApi = this.getGridOptions().api
      this.properties.makeInvoiceMethod = this.searchConditions.makeInvoiceMethod
      this.getIsAr()
      if (makeInvoiceMethod === 3 || makeInvoiceMethod === 4) {
        this.makeInvoiceProperties.isHedge = false
        this.makeInvoiceProperties.isAr = this.properties.isAr
        this.makeInvoiceProperties.makeInvoiceMethod = makeInvoiceMethod
        this.makeInvoiceProperties.isSkipInvoiceFrom = false
        // 请求后台，返回开票界面的树状结构数据源以及相关基础属性
        await getGridSelectedIds(this.getGridOptions(), 'uuid').then(ids => {
          this.makeInvoiceProperties.keys = ids
        }).catch(() => {
        })
        this.makeInvoiceProperties.step = 'step1'
        this.makeInvoiceProperties.selectedEntities = this.properties.selectedEntities
        this.makeInvoiceProperties.autoCheckInvoiceAmountEnable = false
        if (this.makeInvoiceProperties.useAutoCheckInvoicing) {
          this.makeInvoiceProperties.autoCheckInvoiceAmountEnable = true
          this.makeInvoiceProperties.autoCheckInvoicingAmount = this.autoCheckInvoiceDialog.amount
        } else {
          this.makeInvoiceProperties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
        }
        this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
      } else {
        this.properties.branchId = this.$store.getters.currentOfficeId // 分公司
        this.properties.inputByDep = this.$store.getters.currentDeptId // 部门
        // this.properties.selectedEntities = getGridSelected(this.getGridOptions())
        // if (this.properties.selectedEntities.length === 0) {
        //   // this.$message.error(this.$t('common.tips.hasOneAtleast'))
        //   switch (makeInvoiceMethod) {
        //     case 1: this.$message.warning('请选择费用！')
        //       break
        //     case 2: this.$message.warning('请选择业务！')
        //       break
        //     case 3: this.$message.warning('请选择账单！')
        //       break
        //     case 4: this.$message.warning('请选择对账单！')
        //       break
        //   }
        //   return
        // }
        // 重置
        this.initMakeInvoice()
        this.initEntities()
        this.setDefaultContent(makeInvoiceMethod)
        this.step = 'step1'
      }
    },
    // 重置开票相关
    initMakeInvoice() {
      this.properties.isHedge = false
      this.properties.typeGroup = 'multi' // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票、title=按抬头开票
      this.properties.invoiceType = 7 // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
      this.properties.groupingMakeType = 1 // 发票种类：0=纸质发票、1=电子发票
      this.properties.currencyGroup = 0 // 分币种开票：0=拆分币种开票、1=合并币种
      this.properties.cbAssignCurrency = true // 指定发票币种
      this.properties.groupingCurrencyType = 0 // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      this.properties.currency = 'RMB' // 币种（固定默认RMB）
      this.properties.allowModifyCurrency = false // 是否允许修改币种（静默透传）
      this.properties.billingRateMap = {} // 账单币种、账单汇率
      this.properties.isGenCostInvoice = false // 生成成本发票开关已移除，固定为 false
      this.properties.costInvoiceProp = {}
      this.properties.invoiceGoodsName = {} // 发票项目名称
      this.properties.settleDepartment = 0 // 结算部门
      this.properties.settleDepartmentPrefix = '' // 结算部门归属工作号
      this.properties.otherCurrencys = [] // 其它币种
      this.properties.otherRates = [] // 其它币种汇率
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      this.properties.rateCache = {} // 对比发票币种的汇率
      // 默认开票信息
      if (LocalStorageUtilsNew.hasConfiguration('invoceFormPage_' + this.properties.isAr)) {
        const item = LocalStorageUtilsNew.getConfiguration('invoceFormPage_' + this.properties.isAr)
        console.log('invoceFormPage_' + this.properties.isAr, item)
        this.properties.typeGroup = item.typeGroup
        this.properties.invoiceType = item.invoiceType
        this.properties.currency = item.currency
        this.properties.allowModifyCurrency = item.hasOwnProperty('allowModifyCurrency') ? item.allowModifyCurrency : true
        this.properties.groupingCurrencyType = item.groupingCurrencyType
        this.properties.groupingMakeType = item.groupingMakeType
        if (this.properties.groupingCurrencyType === 0) {
          this.properties.currencyGroup = 1
          this.properties.cbAssignCurrency = true
        } else if (this.properties.groupingCurrencyType === 1) {
          this.properties.currencyGroup = 0
          this.properties.cbAssignCurrency = true
        } else if (this.properties.groupingCurrencyType === 2) {
          this.properties.currencyGroup = 0
          this.properties.cbAssignCurrency = false
        }
      }
      if (this.properties.allowModifyCurrency === false) {
        this.properties.currency = 'RMB'
      }
      this.properties.autoCheckInvoiceAmountEnable = false
      if (this.properties.useAutoCheckInvoicing) {
        this.properties.autoCheckInvoiceAmountEnable = true
        this.properties.autoCheckInvoicingAmount = this.autoCheckInvoiceDialog.amount
      } else {
        this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
      }
    },
    toHedgeMakeInvoicePage() {
      this.properties.selectedEntities = getGridSelected(this.getGridOptions())
      const makeInvoiceMethod = this.pageMode === 0 ? this.searchConditions.makeInvoiceMethod : this.searchConditionsHedge.makeInvoiceMethod
      if (this.properties.selectedEntities.length === 0) {
        // this.$message.error(this.$t('common.tips.hasOneAtleast'))
        switch (makeInvoiceMethod) {
          case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
            break
          case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
            break
          case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
            break
          case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
            break
        }
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.gridApi = this.getGridOptions().api
      // 结算对象
      if (!this.checkAccountId(this.properties.selectedEntities)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
        return
      }
      // 收付方式
      this.properties.makeInvoiceMethod = this.searchConditions.makeInvoiceMethod
      this.getIsAr()
      if (this.properties.isAr) {
        this.searchConditionsHedge.paymentType = 0
      } else {
        this.searchConditionsHedge.paymentType = 1
      }
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      const keys = []
      if ([1, 3, 4].includes(this.properties.makeInvoiceMethod)) {
        for (const item of this.properties.selectedEntities) {
          keys.push(item.uuid)
        }
      } else if (this.properties.makeInvoiceMethod === 2) {
        for (const item of this.properties.selectedEntities) {
          item.charges.split(',').forEach(function(key) {
            keys.push(key)
          })
        }
      }
      this.makeInvoiceProperties.keys = keys
      this.searchConditionsHedge.exceptKeys = keys
      console.log('exceptKeys', keys)
      // 默认高级查询条件：结算单位
      this.searchConditionsHedge.accountId = this.properties.selectedEntities[0].accountId
      console.log('accountId', this.searchConditionsHedge.accountId)

      // 每次进来清空上一次的查询结果
      // CARGO-34471 开票-对冲开票数据无法自动带出
      this.chargeGridHedge.rowData = []
      this.billingJobGridHedge.rowData = []
      this.billingGridHedge.rowData = []
      this.billingGroupGridHedge.rowData = []

      this.pageMode = 1
      // const self = this
      // getGridSelectedIds(this.getGridOptions()).then(ids => {
      //   if (ids.length === 0) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // todo 切换到对冲收票页面模式
      //     // eslint-disable-next-line no-unused-vars
      //     const rowDataSelected = { ...getGridSelected(this.getGridOptions())[0] }
      //     this.pageMode = 1
      //   }
      // })
    },
    // InvoiceManager.showInvoice
    async initEntities() {
      console.log('initEntities')
      this.properties.entities = []
      const keys = []
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      if (this.properties.makeInvoiceMethod === 1) {
        for (const item of this.properties.selectedEntities) {
          keys.push(item.uuid)
        }
      } else if (this.properties.makeInvoiceMethod === 2) {
        for (const item of this.properties.selectedEntities) {
          item.charges.split(',').forEach(function(key) {
            keys.push(key)
          })
        }
      }
      //
      if (keys.length === 0) return
      if (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2) {
        const requestBody = { 'keys': keys }
        console.log('keys', requestBody)
        this.loading = getLoading()
        await getNotInvoiceCharges(requestBody).then(res => {
          console.log('getNotInvoiceCharges', res)
          this.properties.entities = res.data
        }).finally(() => {
          this.loading.close()
        })
      }
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return
      }
      // 对冲开票
      if (this.properties.isHedge) {
        await this.initEntitiesHedge()
        if (this.properties.hedgeEntities.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
          return
        }
      }
      //
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      this.properties.allEntities.push(...this.properties.hedgeEntities)
      //
      this.toQueryInvoiceGoodsName()
      //
      this.checkBillingRate()
      if (this.hmToFinanceApi) {
        const chargeMap = new Map()
        for (const item of this.properties.allEntities) {
          if (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2) { // 按费用/业务
            chargeMap.set(item.uuid, item)
          } else if (item.entity === 'charge') {
            chargeMap.set(item.uuid, item)
          }
        }
        if (chargeMap.size > 0) {
          const fkUuids = Array.from(chargeMap.keys, p => `'${p}'`).join(',')
          queryChargePushRecord({ interfaceCategory: 4, fkUuids }).then(res => {
            for (const record of res.data) {
              const charge = chargeMap.get(record.fkUuid)
              if (charge) {
                charge.chargeSyncExternalStatus = record.sendStatus
                charge.chargeSyncExternalFailReason = record.sendResult
              }
            }
          })
        }
      }
    },
    async initEntitiesHedge() {
      console.log('initEntitiesHedge')
      this.properties.hedgeEntities = []
      if (!this.properties.isHedge) return
      const keys = []
      if (this.properties.selectedEntitiesHedge.length === 0) {
        return
      }
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      if (this.properties.makeInvoiceMethodHedge === 1) {
        for (const item of this.properties.selectedEntitiesHedge) {
          keys.push(item.uuid)
        }
      } else if (this.properties.makeInvoiceMethodHedge === 2) {
        for (const item of this.properties.selectedEntitiesHedge) {
          item.charges.split(',').forEach(function(key) {
            keys.push(key)
          })
        }
      }
      //
      if (keys.length === 0) return
      if (this.properties.makeInvoiceMethodHedge === 1 || this.properties.makeInvoiceMethodHedge === 2) {
        const requestBody = { 'keys': keys }
        console.log('keys', requestBody)
        this.loading = getLoading()
        await getNotInvoiceCharges(requestBody).then(res => {
          console.log('getNotInvoiceCharges', res)
          this.properties.hedgeEntities = res.data
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 发票项目名称列表
    toQueryInvoiceGoodsName() {
      this.properties.invoiceGoodsNameList = []
      const requestBody = { 'officeId': this.$store.getters.currentOfficeId }
      console.log('officeId', requestBody)
      this.loading = getLoading()
      queryInvoiceGoodsName(requestBody).then(res => {
        console.log('queryInvoiceGoodsName', res)
        this.properties.invoiceGoodsNameList = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    toChangePageMode() {
      this.pageMode = 0
    },
    // 对冲开票页面模式 确定btn click event
    toHedgeMakeInvoice() {
      this.properties.branchId = this.$store.getters.currentOfficeId // 分公司
      this.properties.inputByDep = this.$store.getters.currentDeptId // 部门
      this.properties.selectedEntitiesHedge = getGridSelected(this.getGridOptions())
      if (this.properties.selectedEntitiesHedge.length === 0) {
        // this.$message.error(this.$t('common.tips.hasOneAtleast'))
        const makeInvoiceMethod = this.pageMode === 0 ? this.searchConditions.makeInvoiceMethod : this.searchConditionsHedge.makeInvoiceMethod
        switch (makeInvoiceMethod) {
          case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
            break
          case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
            break
          case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
            break
          case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
            break
        }
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId || this.queryOfficeIdHedge !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.properties.makeInvoiceMethod = this.searchConditions.makeInvoiceMethod
      this.getIsAr()
      //
      this.properties.isHedge = true
      this.properties.makeInvoiceMethodHedge = this.searchConditionsHedge.makeInvoiceMethod
      if ([3, 4].includes(this.properties.makeInvoiceMethod) || [3, 4].includes(this.properties.makeInvoiceMethodHedge)) {
        this.makeInvoiceProperties.isHedge = this.properties.isHedge
        this.makeInvoiceProperties.isAr = this.properties.isAr
        this.makeInvoiceProperties.makeInvoiceMethod = this.properties.makeInvoiceMethod
        this.makeInvoiceProperties.makeInvoiceMethodHedge = this.properties.makeInvoiceMethodHedge
        this.makeInvoiceProperties.isSkipInvoiceFrom = false
        // 请求后台，返回开票界面的树状结构数据源以及相关基础属性
        const keys = []
        if ([1, 3, 4].includes(this.properties.makeInvoiceMethodHedge)) {
          for (const item of this.properties.selectedEntitiesHedge) {
            keys.push(item.uuid)
          }
        } else { // 按业务
          for (const item of this.properties.selectedEntitiesHedge) {
            item.charges.split(',').forEach(function(key) {
              keys.push(key)
            })
          }
        }
        this.makeInvoiceProperties.hedgeKeys = keys
        this.makeInvoiceProperties.step = 'step1'
        this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
      } else {
        this.initEntities()
        this.step = 'step1'
      }

      /*
      const self = this
      getGridSelectedIds(this.getGridOptions()).then(ids => {
        if (ids.length === 0) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          // 开启'对冲开票/对冲收票'弹窗页
          // eslint-disable-next-line no-unused-vars
          const rowDataSelected = { ...getGridSelected(this.getGridOptions())[0] }
          // this.makeInvoiceDialog.visible = true
          // this.makeInvoiceDialog.title = this.pageMode === 0 ? this.makeInvoiceBtnText.makeInvoiceBtn : this.makeInvoiceBtnText.hedgeMakeInvoiceBtn
          // this.makeInvoiceDialog.params = {
          //   // todo: 根据选择行的开票方式赋值参数
          //   mode: 1,
          //   // todo: 根据选择行的收付方式赋值参数 不能直接使用搜索条件值
          //   paymentType: this.searchConditions.paymentType,
          //   // todo: 根据选择行的开票方式赋值参数 不能直接使用搜索条件中的开票方式
          //   makeInvoiceMethod: this.searchConditions.makeInvoiceMethod,
          //   // todo: 原始的开票方式，切换到对冲页面模式之前数据的开票方式
          //   originMakeInvoiceMethod: 1
          // }
        }
      })
      */
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = this.billingGrid.rowData.find(item => item.uuid === value)
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    // 获取cargo-ag-grid表格组件的gridOptions
    getGridOptions() {
      const makeInvoiceMethod = this.pageMode === 0 ? this.searchConditions.makeInvoiceMethod : this.searchConditionsHedge.makeInvoiceMethod
      let gridOptions
      switch (makeInvoiceMethod) {
        case 1: gridOptions = this.pageMode === 0 ? this.chargeGrid.gridOptions : this.chargeGridHedge.gridOptions
          break
        case 2: gridOptions = this.pageMode === 0 ? this.billingJobGrid.gridOptions : this.billingJobGridHedge.gridOptions
          break
        case 3: gridOptions = this.pageMode === 0 ? this.billingGrid.gridOptions : this.billingGridHedge.gridOptions
          break
        case 4: gridOptions = this.pageMode === 0 ? this.billingGroupGrid.gridOptions : this.billingGroupGridHedge.gridOptions
          break
      }
      return gridOptions
    },
    lastFinsh() {
      this.makeInvoiceDialog.visible = false
    },
    // 下一步、上一步
    toStepHandler(data) {
      if (StrUtils.isEmpty(data)) {
        // 对冲开票重置
        if (this.pageMode === 1) {
          // this.pageMode = 0
          // this.chargeGridHedge.rowData = []
          // this.billingJobGridHedge.rowData = []
          // this.billingGridHedge.rowData = []
          // this.billingGroupGridHedge.rowData = []
          // this.searchConditionsHedge.total = 0
        }
      }
      this.step = data
      console.log('step:', this.step)
      if (!this.step) {
        this.properties.autoCheckInvoicingAmount = 0.0
        this.properties.useAutoCheckInvoicing = false
        this.properties.autoCheckInvoiceAmountEnable = false
        this.makeInvoiceProperties.useAutoCheckInvoicing = false
        this.makeInvoiceProperties.autoCheckInvoiceAmountEnable = false
        this.makeInvoiceProperties.autoCheckInvoicingAmount = 0.0
      }
    },
    generatedHandler(data) {
      console.log('generatedHandler:', data)
      //
      this.properties.currentPage = 1
      this.pageChange()
      this.step = data
      // 列表刷新
      this.$nextTick(() => {
        this.pageMode = 0
        if (this.gridApi) {
          this.gridApi.updateRowData({ remove: this.properties.selectedEntities })
        } else {
          this.getGridOptions().api.updateRowData({ remove: this.properties.selectedEntities })
        }
      })
    },
    // 保存开票选项到缓存
    toSaveCatchHandler() {
      const setting = {}
      setting.paymentType = this.searchConditions.paymentType
      setting.chargeTypeGroup = this.searchConditions.chargeTypeGroup
      setting.makeInvoiceMethod = this.searchConditions.makeInvoiceMethod
      const makeInvoiceSaveCache = 'Make_Invoice_Save_Cache'
      LocalStorageUtilsNew.setConfiguration(makeInvoiceSaveCache, setting)
    },
    // 切换发票
    pageChange(data) {
      console.log('pageChange:', data)
      //
      this.properties.totalPage = this.properties.invoices.length
      if (this.properties.currentPage > this.properties.totalPage) { this.properties.currentPage = this.properties.totalPage }
      if (this.properties.currentPage < 1) { this.properties.currentPage = 1 }
      //
      if (this.properties.totalPage > 0) {
        this.properties.invoice = this.properties.invoices[this.properties.currentPage - 1]
        // 增票合并/显示明细
        if (this.properties.invoice.ar && [2, 3].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.properties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.properties.rbgShowChargeDetail = 'detail'
            }
          }
        } else if (this.properties.invoice.ar && [0, 1, 4].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          if (!StrUtils.isEmpty(this.properties.invoice.partAmount) && this.properties.invoice.partAmount.indexOf('\n') > -1) {
            this.properties.rbgShowChargeDetail = 'detail'
          }
        } else if (this.properties.invoice.ar && [6, 7].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.properties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.properties.rbgShowChargeDetail = 'detail'
            }
          }
        } else {
          this.properties.rbgShowChargeDetail = 'merge'
        }
        //
        this.$refs.makeInvoiceDialog.initBaseData()
      }
    },
    //
    checkAccountId(items) {
      let accountId = 0
      for (const item of items) {
        if (accountId === 0) {
          accountId = Number(item.accountId)
        } else {
          if (accountId !== Number(item.accountId)) {
            return false
          }
        }
      }
      return true
    },
    // 账单汇率相同时，支持选择按账单汇率开票：当所选择的费用均已生成账单，且该币种的账单汇率相同时
    checkBillingRate() {
      console.log('checkBillingRate')
      this.properties.billingRateMap = {}
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      if (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2) {
        for (const charge of this.properties.allEntities) {
          // 没开账单
          if (StrUtils.isEmpty(charge.billingUuid)) {
            this.properties.billingRateMap = {}
            return
          }
          // 账单币种
          if (this.properties.billingRateMap.currency) {
            if (this.properties.billingRateMap.currency !== charge.billingCurrency) {
              this.properties.billingRateMap = {}
              return
            }
          } else {
            this.properties.billingRateMap.currency = charge.billingCurrency
          }
          // sourceCurrency1
          if (!StrUtils.isEmpty(charge.sourceCurrency1)) {
            if (this.properties.billingRateMap[charge.sourceCurrency1]) {
              if (this.properties.billingRateMap[charge.sourceCurrency1] !== charge.sourceRate1) {
                this.properties.billingRateMap = {}
                return
              }
            } else {
              this.properties.billingRateMap[charge.sourceCurrency1] = charge.sourceRate1
            }
          }
          // sourceCurrency2
          if (!StrUtils.isEmpty(charge.sourceCurrency2)) {
            if (this.properties.billingRateMap[charge.sourceCurrency2]) {
              if (this.properties.billingRateMap[charge.sourceCurrency2] !== charge.sourceRate2) {
                this.properties.billingRateMap = {}
                return
              }
            } else {
              this.properties.billingRateMap[charge.sourceCurrency2] = charge.sourceRate2
            }
          }
          // sourceCurrency3
          if (!StrUtils.isEmpty(charge.sourceCurrency3)) {
            if (this.properties.billingRateMap[charge.sourceCurrency3]) {
              if (this.properties.billingRateMap[charge.sourceCurrency3] !== charge.sourceRate3) {
                this.properties.billingRateMap = {}
                return
              }
            } else {
              this.properties.billingRateMap[charge.sourceCurrency3] = charge.sourceRate3
            }
          }
        }
      }
    },
    // 参照cargoware：如果行类型Charge/IWriteoffable，根据第一条记录
    getIsAr() {
      this.properties.isAr = this.searchConditions.paymentType === 1
      // 参照cargoware：如果行类型Charge/IWriteoffable，根据第一条记录
      if (this.properties.makeInvoiceMethod === 1) { // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        // this.properties.isAr = this.properties.selectedEntities[0].isReceivable
        let r = 0 // 应收
        let p = 0 // 应付
        for (const charge of this.properties.selectedEntities) {
          const amount = new BigNumber(charge.amount)
          const exchangeRate = new BigNumber(charge.rate)
          const num = NumberUtils.ToFixed2(amount * exchangeRate, 2)
          if (charge.receivable) {
            r += num
          } else {
            p += num
          }
        }
        if (r !== 0) {
          r = NumberUtils.ToFixed2(r, 2)
        }
        if (p !== 0) {
          p = NumberUtils.ToFixed2(p, 2)
        }
        this.properties.isAr = r > p
      } else if (this.properties.makeInvoiceMethod === 2) {
        this.properties.isAr = this.properties.selectedEntities[0].isAr
      } else if (this.properties.makeInvoiceMethod === 3) {
        this.properties.isAr = this.properties.selectedEntities[0].ar
      } else if (this.properties.makeInvoiceMethod === 4) {
        this.properties.isAr = this.properties.selectedEntities[0].ar
      }
    },
    //
    async initCustomSearchItems() {
      const defaultSearchFields = []
      if (this.searchConditions.makeInvoiceMethod === 1) {
        const chargeStates = []
        if (this.searchConditions.paymentType === -1) {
          // 两个配置参数都开启,费用状态显示栏位取两者并集
          if (StrUtils.isEmpty(this.searchConditions.invoiceReceiveChargeState) && StrUtils.isEmpty(this.searchConditions.invoicePayChargeState)) {
            this.searchConditions.invoiceReceiveChargeState.split(',').forEach(function(value) {
              chargeStates.push(Number(value))
            })
            //
            this.searchConditions.invoicePayChargeState.split(',').forEach(function(value) {
              if (chargeStates.indexOf(Number(value)) === -1) {
                chargeStates.push(Number(value))
              }
            })
          }
        } else if (this.searchConditions.paymentType === 1) {
          this.searchConditions.invoiceReceiveChargeState.split(',').forEach(function(value) {
            chargeStates.push(Number(value))
          })
        } else {
          this.searchConditions.invoicePayChargeState.split(',').forEach(function(value) {
            chargeStates.push(Number(value))
          })
        }
        //
        const dataProvider = []
        if (chargeStates.length > 0) {
          // dataProvider.push(CommonState.getStateByCode(ChargeConstants.CHARGE_STATES, null)) // -请选择-
          chargeStates.forEach(function(code) {
            dataProvider.push(CommonState.getStateByCode(ChargeConstants.CHARGE_STATES, code))
          })
        }
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'charge.CHARGE_STATE'
        searchField.itemLabel = 'Invoice.invoice_feeStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_STATES'
        searchField.dropdownDataRef = dataProvider.length > 0 ? '' : 'ChargeConstants.CHARGE_STATES'
        searchField.dataProvider = dataProvider
        if (dataProvider.length === 0) {
          searchField.valueExpression = ''
        }
        searchField.lock = false
        searchField.defaultValue = []
        searchField.action = 2
        defaultSearchFields.push(searchField.formatObj2Json())
        if (this.useOrderCenterMode) {
          const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
          const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
          offices.forEach(row => { row.code = row.officeId }) // ID
          let searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
          searchField.defaultConditionVal = 0
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'cooperate.BRANCH_ID'
          searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
          searchField.itemValue = []
          searchField.tagValue = 'officeId'
          searchField.defaultSelected = 1
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = offices
          defaultSearchFields.push(searchField.formatObj2Json())
          // 协作业务类型
          const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
          searchField.defaultConditionVal = 0
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'cooperate.BUSINESS_TYPE'
          searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
          searchField.itemValue = []
          searchField.defaultSelected = 1
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = cooperationTypes
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        this.customSearchItems = defaultSearchFields
      }

      if (this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, this.customSearchItems)
      }
      //
      // this.searchItemAutoInit = true
    },
    // 列表checkBox选中变更事件
    // 按费用
    toRefreshSelectedCountChargeGrid() {
      this.chargeGridFilterChanged()
    },
    // 列表筛选变更事件
    chargeGridFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.chargeGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.chargeGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.chargeGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }
    },
    // 按账单
    toRefreshSelectedCountBillingGrid() {
      this.billingGridFilterChanged()
      // this.once.excute(this.refreshSelectedCountBillingGrid, [], 200)
    },
    billingGridFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountBillingGrid, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billingGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed && node.data) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.billingGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGrid, [], 200)
            }
            if (hasDisplay.length < this.billingGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountBillingGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountBillingGrid(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillingGrid.dataProvider = selections
        this.totalAmountToCurrencyBillingGrid.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillingGrid.dataProvider = selections
        this.totalAmountToCurrencyBillingGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillingGrid.dataProvider = this.billingGrid.rowData
        this.totalAmountToCurrencyBillingGrid.selectedCount = 0
      }
    },
    // 按对账单
    toRefreshSelectedCountBillingGroupGrid() {
      this.billingGroupGridFilterChanged()
      // this.once.excute(this.refreshSelectedCountBillingGroupGrid, [], 200)
    },
    billingGroupGridFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountBillingGroupGrid, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billingGroupGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.billingGroupGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGroupGrid, [], 200)
            }
            if (hasDisplay.length < this.billingGroupGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGroupGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountBillingGroupGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountBillingGroupGrid(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = selections
        this.totalAmountToCurrencyBillingGroupGrid.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = selections
        this.totalAmountToCurrencyBillingGroupGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = this.billingGroupGrid.rowData
        this.totalAmountToCurrencyBillingGroupGrid.selectedCount = 0
      }
    },
    // 按费用红冲
    toRefreshSelectedCountChargeGridHedge() {
      console.log('toRefreshSelectedCountChargeGridHedge')
      this.chargeGridHedgeFilterChanged()
      // this.once.excute(this.refreshSelectedCountChargeGridHedge, [], 200)
    },
    chargeGridHedgeFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGridHedge, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.chargeGridHedge.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.chargeGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGridHedge, [], 200)
            }
            if (hasDisplay.length < this.chargeGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGridHedge, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGridHedge, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGridHedge(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyChargeGridHedge.dataProvider = selections
        this.totalAmountToCurrencyChargeGridHedge.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyChargeGridHedge.dataProvider = selections
        this.totalAmountToCurrencyChargeGridHedge.selectedCount = 0
      } else {
        this.totalAmountToCurrencyChargeGridHedge.dataProvider = this.chargeGridHedge.rowData
        this.totalAmountToCurrencyChargeGridHedge.selectedCount = 0
      }
    },
    // 按业务
    toRefreshSelectedCountBillingJobGrid() {
      console.log('toRefreshSelectedCountBillingJobGrid')
      this.billingJobGridFilterChanged()
      // this.once.excute(this.refreshSelectedCountBillingJobGrid, [], 200)
    },
    billingJobGridFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountBillingJobGrid, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billingJobGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.billingJobGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingJobGrid, [], 200)
            }
            if (hasDisplay.length < this.billingJobGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingJobGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountBillingJobGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountBillingJobGrid(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillingJobGrid.dataProvider = this.getChargeDetailFotChargeJob(selections)
        this.totalAmountToCurrencyBillingJobGrid.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillingJobGrid.dataProvider = this.getChargeDetailFotChargeJob(selections)
        this.totalAmountToCurrencyBillingJobGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillingJobGrid.dataProvider = this.getChargeDetailFotChargeJob(this.billingJobGrid.rowData)
        this.totalAmountToCurrencyBillingJobGrid.selectedCount = 0
      }
    },
    // 按业务红冲
    toRefreshSelectedCountBillingJobGridHedge() {
      console.log('toRefreshSelectedCountBillingJobGridHedge')
      this.billingJobGridHedgeFilterChanged()
      // this.once.excute(this.refreshSelectedCountBillingJobGridHedge, [], 200)
    },
    billingJobGridHedgeFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountBillingJobGridHedge, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billingJobGridHedge.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.billingJobGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingJobGridHedge, [], 200)
            }
            if (hasDisplay.length < this.billingJobGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingJobGridHedge, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountBillingJobGridHedge, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountBillingJobGridHedge(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillingJobGridHedge.dataProvider = selections
        this.totalAmountToCurrencyBillingJobGridHedge.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillingJobGridHedge.dataProvider = selections
        this.totalAmountToCurrencyBillingJobGridHedge.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillingJobGridHedge.dataProvider = this.billingJobGridHedge.rowData
        this.totalAmountToCurrencyBillingJobGridHedge.selectedCount = 0
      }
    },
    // 按账单红冲
    toRefreshSelectedCountBillingGridHedge() {
      this.billingGridHedgeFilterChanged()
      // this.once.excute(this.refreshSelectedCountBillingGridHedge, [], 200)
    },
    billingGridHedgeFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountBillingGridHedge, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billingGridHedge.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.billingGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGridHedge, [], 200)
            }
            if (hasDisplay.length < this.billingGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGridHedge, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountBillingGridHedge, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountBillingGridHedge(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillingGridHedge.dataProvider = selections
        this.totalAmountToCurrencyBillingGridHedge.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillingGridHedge.dataProvider = selections
        this.totalAmountToCurrencyBillingGridHedge.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillingGridHedge.dataProvider = this.billingGridHedge.rowData
        this.totalAmountToCurrencyBillingGridHedge.selectedCount = 0
      }
    },
    // 按对账单红冲
    toRefreshSelectedCountBillingGroupGridHedge() {
      this.billingGroupGridHedgeFilterChanged()
      // this.once.excute(this.refreshSelectedCountBillingGroupGridHedge, [], 200)
    },
    billingGroupGridHedgeFilterChanged() {
      const selections = getGridSelected(this.getGridOptions())
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountBillingGroupGridHedge, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billingGroupGridHedge.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.billingGroupGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGroupGridHedge, [], 200)
            }
            if (hasDisplay.length < this.billingGroupGridHedge.rowData.length) {
              this.once.excute(this.refreshSelectedCountBillingGroupGridHedge, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountBillingGroupGridHedge, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountBillingGroupGridHedge(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillingGroupGridHedge.dataProvider = selections
        this.totalAmountToCurrencyBillingGroupGridHedge.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillingGroupGridHedge.dataProvider = selections
        this.totalAmountToCurrencyBillingGroupGridHedge.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillingGroupGridHedge.dataProvider = this.billingGroupGridHedge.rowData
        this.totalAmountToCurrencyBillingGroupGridHedge.selectedCount = 0
      }
    },
    // 开票方式发生改变
    async makeInvoiceMethodChange() {
      this.showLoading = true
      this.appendQuery = false
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      if (searchConditions.makeInvoiceMethod === 3) {
        await this.tabBillingHp.changeCustomSearchItems()
      } else if (searchConditions.makeInvoiceMethod === 4) {
        await this.tabBillingGroupHp.changeCustomSearchItems()
      } else {
        await this.initCustomSearchItems()
      }
      this.resetAutoCheckInvoicing()
    },
    // 重新加载列表数据
    reloadData() {
      this.showLoading = false
      const setting = {}
      setting.paymentType = this.searchConditions.paymentType
      setting.chargeTypeGroup = this.searchConditions.chargeTypeGroup
      setting.makeInvoiceMethod = this.searchConditions.makeInvoiceMethod
      const makeInvoiceSaveCache = 'Make_Invoice_Save_Cache'
      LocalStorageUtilsNew.setConfiguration(makeInvoiceSaveCache, setting)
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      if (searchConditions.makeInvoiceMethod === 3) {
        this.tabBillingHp.toAdvQueryList(lodash.cloneDeep(searchConditions.snapshotConditionsBilling), false, true)
      } else if (searchConditions.makeInvoiceMethod === 4) {
        this.tabBillingGroupHp.toAdvQueryList(lodash.cloneDeep(searchConditions.snapshotConditionsBillingGroup), false, false, true)
      }
    },
    // 取消确认账单
    unConfirmBilling() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.billingGrid.gridOptions) : getGridSelected(this.billingGridHedge.gridOptions)
      const keys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        const state = billing.state
        if (state === Number(BillingConstants.BILLING_VERIFIED.code) && !billing.billingGroupUuid && billing.invoiceState === Number(BillingConstants.INVOICE_STATE_NOT_INVOICE.code)) {
          keys.push({ 'key': billing.uuid, 'version': billing.version })
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
        return
      }
      this.tabBillingHp.unConfirmBilling(keys)
    },
    // 标记
    signEvent() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.billingGrid.gridOptions) : getGridSelected(this.billingGridHedge.gridOptions)
      const billingKeys = []
      for (const billing of chooseRows) {
        if (!billing.mark) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_MBEIRPSUB'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBillToMark'))
        return
      }
      this.signBillingDialog.billingKeys = billingKeys
      this.signBillingDialog.visible = true
    },
    // 取消标记
    cancelSignEvent() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.billingGrid.gridOptions) : getGridSelected(this.billingGridHedge.gridOptions)
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      const billingKeys = []
      for (const billing of chooseRows) {
        if (billing.mark) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_UBEIRPSMB'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBillToMark'))
        return
      }
      cancelSignBilling(billingKeys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_MarkCancelledSuccessfully'))
        this.tabBillingHp.toAdvQueryList(searchConditions.snapshotConditions)
      }).finally(() => {
      })
    },
    signBillingCallBack() {
      this.tabBillingHp.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    // 费用标记回调
    signChargeCallBack() {
      const loading = getLoading()
      signCharge(this.signChargeDialog.keys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Marked'))
        this.toQueryChargeList()
      }).finally(() => {
        loading.close()
      })
    },
    // 业务标记回调
    signBusinessCallBack() {
      const loading = getLoading()
      signJob(this.signBusinessDialog.keys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Marked'))
        this.toQueryChargeJobList()
      }).finally(() => {
        loading.close()
      })
    },
    // 费用标记
    signChargeEvent() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.chargeGrid.gridOptions) : getGridSelected(this.chargeGridHedge.gridOptions)
      const billingKeys = []
      for (const charge of chooseRows) {
        if (!charge.marks) {
          if (charge.uuid && billingKeys.indexOf(charge.uuid) < 0) {
            billingKeys.push(charge.uuid)
          }
        } else {
          this.$message.warning(this.$t('Clearing.MarkRecordExistsMarkedCharge'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseSelectChargeToMark'))
        return
      }
      this.signChargeDialog.keys = billingKeys
      this.signChargeDialog.visible = true
    },
    // 费用取消标记
    cancelSignChargeEvent() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.chargeGrid.gridOptions) : getGridSelected(this.chargeGridHedge.gridOptions)
      const billingKeys = []
      for (const charge of chooseRows) {
        if (charge.marks) {
          if (charge.uuid && billingKeys.indexOf(charge.uuid) < 0) {
            billingKeys.push(charge.uuid)
          }
        } else {
          this.$message.warning(this.$t('Clearing.MarkRecordExistsNoMarkedCharge'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseSelectChargeToMark'))
        return
      }
      const loading = getLoading()
      cancelSignCharge(billingKeys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_MarkCancelledSuccessfully'))
        this.toQueryChargeList()
      }).finally(() => {
        loading.close()
      })
    },
    // 业务标记
    signBusinessEvent() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.billingJobGrid.gridOptions) : getGridSelected(this.billingJobGridHedge.gridOptions)
      const billingKeys = []
      for (const business of chooseRows) {
        if (!business.marks) {
          if (business.uuid && billingKeys.indexOf(business.uuid) < 0) {
            billingKeys.push(business.uuid)
          }
        } else {
          this.$message.warning(this.$t('Clearing.MarkRecordExistsMarkedJob'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseSelectJobToMark'))
        return
      }
      this.signBusinessDialog.keys = billingKeys
      this.signBusinessDialog.visible = true
    },
    // 业务取消标记
    cancelSignBusinessEvent() {
      const chooseRows = this.pageMode === 0 ? getGridSelected(this.billingJobGrid.gridOptions) : getGridSelected(this.billingJobGridHedge.gridOptions)
      const billingKeys = []
      for (const business of chooseRows) {
        if (business.marks) {
          if (business.uuid && billingKeys.indexOf(business.uuid) < 0) {
            billingKeys.push(business.uuid)
          }
        } else {
          this.$message.warning(this.$t('Clearing.MarkRecordExistsNoMarkedJob'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseSelectJobToMark'))
        return
      }
      const loading = getLoading()
      cancelSignJob(billingKeys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_MarkCancelledSuccessfully'))
        this.toQueryChargeJobList()
      }).finally(() => {
        loading.close()
      })
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.makeInvoice')
        const footer = document.getElementById('footer-wrapper2')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    autoCheckInvoicing() {
      this.autoCheckInvoiceDialog.amount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
      this.autoCheckInvoiceDialog.visible = true
    },
    // 设置开票金额，确定事件,勾选列表符合条件的数据
    async autoCheckInvoiceConfirm() {
      const makeInvoiceMethod = this.searchConditions.makeInvoiceMethod
      const amount = this.autoCheckInvoiceDialog.amount
      if (!amount || amount === 0) {
        this.$message.warning(this.$t('Invoice.AutoAmountCanNotZero'))
        return
      }
      const localCurrency = RateUtil.localCurrencyByOffice()
      let result = {}
      if (makeInvoiceMethod === 1) {
        this.properties.useAutoCheckInvoicing = true
        this.properties.autoCheckInvoicingAmount = amount
        result = await ClearingUtils.autoCheckInvoicing([...this.chargeGrid.rowData], amount, 'isReceivable', 'currency', 'amount', '', makeInvoiceMethod, localCurrency)
      } else if (makeInvoiceMethod === 2) {
        this.properties.useAutoCheckInvoicing = true
        this.properties.autoCheckInvoicingAmount = amount
        result = await ClearingUtils.autoCheckInvoicing([...this.billingJobGrid.rowData], amount, 'isAr', 'chargeCurrency', 'chargeAmountTotal', '', makeInvoiceMethod, localCurrency)
      } else if (makeInvoiceMethod === 3) {
        this.makeInvoiceProperties.useAutoCheckInvoicing = true
        this.makeInvoiceProperties.autoCheckInvoicingAmount = amount
        result = await ClearingUtils.autoCheckInvoicing([...this.billingGrid.rowData], amount, 'ar', 'currency', 'amount', '', makeInvoiceMethod, localCurrency)
      } else if (makeInvoiceMethod === 4) {
        this.makeInvoiceProperties.useAutoCheckInvoicing = true
        this.makeInvoiceProperties.autoCheckInvoicingAmount = amount
        result = await ClearingUtils.autoCheckInvoicing([...this.billingGroupGrid.rowData], amount, 'ar', 'currency', 'amount', '', makeInvoiceMethod, localCurrency)
      }
      this.autoCheckInvoiceDialog.visible = false
      this.autoCheckInvoiceDialog.selectKeys = result.selectedKeys
      if (result.selectedKeys.length > 0) {
        this.gridApi = this.getGridOptions().api
        const nodes = this.gridApi.getModel().rowsToDisplay
        for (const item of nodes) {
          if (!item.data) {
            continue
          }
          let index = -1
          if (makeInvoiceMethod === 2) {
            index = result.selectedKeys.findIndex(key => key === item.data)
          } else {
            index = result.selectedKeys.findIndex(key => key === item.data.uuid)
          }
          if (index >= 0) {
            item.setSelected(true)
          } else {
            item.setSelected(false)
          }
        }
        if (this.gridApi !== null) {
          this.gridApi.refreshCells({ force: true })
        }
      }
      if (result.message) {
        this.$message.warning(result.message)
      } else {
        this.$message.warning(this.$t('Invoice.AutoCheckInvoicingSuccess', [result.totalAmount]))
      }
    },
    resetAutoCheckInvoicing() {
      this.makeInvoiceProperties.useAutoCheckInvoicing = false
      this.makeInvoiceProperties.autoCheckInvoiceAmountEnable = false
      this.makeInvoiceProperties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
      this.properties.useAutoCheckInvoicing = false
      this.properties.autoCheckInvoiceAmountEnable = false
      this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
    },
    getChargeDetailFotChargeJob(selections) {
      const rowData = []
      if (selections && selections.length > 0) {
        for (const job of selections) {
          const charges = job.charges.split(',')
          const chargeAmounts = job.chargeAmounts.split(',')
          const chargeExchangeRates = job.chargeExchangeRates.split(',')
          if (charges.length === chargeAmounts.length && charges.length === chargeExchangeRates.length) {
            const len = charges.length
            for (let i = 0; i < len; i++) {
              const charge = {}
              charge.isAr = job.isAr
              charge.chargeCurrency = job.chargeCurrency
              charge.chargeAmountTotal = Number(chargeAmounts[i])
              charge.chargeExchangeRate = Number(chargeExchangeRates[i])
              rowData.push(charge)
            }
          }
        }
      }
      return rowData
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 从缓存中获取设置默认值
    setDefaultContent(makeInvoiceMethod) {
      // 设置缓存
      // CARGO-32855 开票-将本次内容设置为默认开票，新增 根据预设开票金额勾选费用 相关内容的保存
      if (LocalStorageUtilsNew.hasConfiguration('invoceFormPage_' + this.properties.isAr)) {
        const item = LocalStorageUtilsNew.getConfiguration('invoceFormPage_' + this.properties.isAr)
        if (item && (makeInvoiceMethod === 1 || makeInvoiceMethod === 2)) { // 按费用、按业务
          if (item.hasOwnProperty('autoCheckInvoicingAmount')) {
            this.properties.autoCheckInvoicingAmount = item.autoCheckInvoicingAmount
          }
          if (item.hasOwnProperty('useAutoCheckInvoicing')) {
            this.properties.useAutoCheckInvoicing = item.useAutoCheckInvoicing
          }
        }
      }
    },
    taxNatureLabelFunction(value) {
      if (!value) {
        return ''
      }
      const taxNatures = value.split(',')
      if (taxNatures.every(p => p === '0')) {
        return this.$t('CargoMsg.Cargo_NotTaxFree')
      } else if (taxNatures.every(p => p === '1')) {
        return this.$t('CargoMsg.Cargo_DutyFree')
      }
      return this.$t('CargoMsg.Cargo_Uncertain')
    },
    showInvoicePoolDialog() {
      const searchConditions = this.pageMode === 0 ? this.searchConditions : this.searchConditionsHedge
      const makeInvoiceMethod = Number(searchConditions.makeInvoiceMethod)
      this.properties.selectedEntities = getGridSelected(this.getGridOptions())
      if (this.properties.selectedEntities.length === 0) {
        switch (makeInvoiceMethod) {
          case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
            break
          case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
            break
          case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
            break
          case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
            break
        }
        return
      }
      this.invoicePoolDialog.sellerTaxNameDefaultValue = (makeInvoiceMethod === 3 || makeInvoiceMethod === 4) ? this.properties.selectedEntities[0].title : this.properties.selectedEntities[0].invoiceTitle
      this.invoicePoolDialog.selectedEntities = this.properties.selectedEntities
      this.invoicePoolDialog.operation = 'collection'
      this.invoicePoolDialog.source = 'invoice'
      this.invoicePoolDialog.makeInvoiceMethod = makeInvoiceMethod
      this.invoicePoolDialog.visible = true
    },
    invoicePoolCallBack() {
      this.$nextTick(() => {
        this.pageMode = 0
        if (this.gridApi) {
          this.gridApi.updateRowData({ remove: this.properties.selectedEntities })
        } else {
          this.getGridOptions().api.updateRowData({ remove: this.properties.selectedEntities })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  #footer-wrapper2 {
    align-items: center;
    .fixedBottom {
      position: fixed;
      bottom: 0;
      right: 15px;
      background: #fff;
    }
  }
  .makeInvoice {
    .el-form-item-search {
      margin-right: 15px;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 14px !important;
      }
      .el-form-item__content {
        .el-radio {
          margin-right: 3px;
          .el-radio__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-checkbox {
          .el-checkbox__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-date-editor {
          //.el-input__prefix {
          //  display: none;
          //}
        }
        .el-input {
          width: 110px;
        }
        .el-input__inner {
          padding-left: 20px !important;
          padding-right: 5px !important;
          width: 110px;
        }
      }
    }
  }
</style>
